// @ts-nocheck
import { useState, useEffect, useRef } from "react";

// ── Constants ─────────────────────────────────────────────────────────────────
const DAYS     = ['Ma','Di','Wo','Do','Vr','Za','Zo'];
const UNITS    = ['g','kg','ml','L','stuks','teentjes','takjes','blik','el','tl','snuf','zak','zijde'];
const SUPPLIERS= ['Slager','Visboer','Groenteman','Zuivel','Droog','Zak','Zijde','Sligro','Makro','Supermarkt','Overig'];
let CAT_ORDER= ['Vlees','Vis & Zeevruchten','Soepen','Bijgerechten','Sauzen & Basis','Overig'];
const CAT_ICONS= {};

// Today index: Ma=0 … Za=5, -1 = zondag
const todayIdx = new Date().getDay()===0?6:new Date().getDay()-1;

// Check cycle: 0=leeg → 1=gepland(amber) → 2=gedaan(groen) → 0
const nextCheck = s => (( s||0)+1)%3;

const BEWAARADVIES = ['', 'Bewaren onder 7°C', 'Bewaren onder -18°C', 'Bewaren op kamertemperatuur'];

// ── Paste recept parser ───────────────────────────────────────────────────────
const PARSE_UNITS = ['kg','g','gr','gram','ml','l','dl','cl','liter','el','tl','eetlepel','theelepel','stuks','stuk','blik','blikken','teen','teentje','teentjes','takje','takjes','snuf','snufje','ons','pond'];
const UNIT_NORM = {gr:'g',gram:'g',liter:'L',dl:'dl',cl:'cl',eetlepel:'el',theelepel:'tl',stuk:'stuks',blikken:'blik',teentje:'teen',teentjes:'teen',takjes:'takje',snufje:'snuf'};

function parseIngLine(line) {
  line = line.trim().replace(/^[-–•*]\s*/, '');
  if (!line || line.length < 2) return null;
  const numRx = /^(\d+(?:[.,]\d+)?)\s*/;
  const unitRxStr = '^(' + PARSE_UNITS.join('|') + ')\\b\\.?\\s*';
  const unitRx = new RegExp(unitRxStr, 'i');
  let rest = line, amount = '', unit = '';
  const numMatch = rest.match(numRx);
  if (numMatch) {
    amount = numMatch[1].replace(',','.');
    rest = rest.slice(numMatch[0].length);
    const um = rest.match(unitRx);
    if (um) { unit = UNIT_NORM[um[1].toLowerCase()] || um[1].toLowerCase(); rest = rest.slice(um[0].length); }
    else unit = 'stuks';
  } else {
    const um = rest.match(unitRx);
    if (um) { unit = UNIT_NORM[um[1].toLowerCase()] || um[1].toLowerCase(); rest = rest.slice(um[0].length); }
    else return null;
  }
  const name = rest.trim();
  if (!name || name.length < 2) return null;
  return { id: uid(), name, amount: amount||'1', unit, supplier: 'Overig' };
}

function parsePasteRecipe(text) {
  const lines = text.split('\n').map(l => l.trim()).filter(Boolean);
  if (!lines.length) return null;
  const title = lines[0];
  const ingredients = [], recipeLines = [];
  for (const line of lines.slice(1)) {
    const ing = parseIngLine(line);
    if (ing) ingredients.push(ing);
    else if (line.length > 3) recipeLines.push(line);
  }
  return { name: title, ingredients, recipe: recipeLines.join('\n') };
}
const ALLERGENEN = ['Gluten','Schaaldieren','Eieren','Vis','Pindas','Soja','Melk','Noten','Selderij','Mosterd','Sesamzaad','Zwaveldioxide','Lupine','Weekdieren'];

// ── Allergeen-trefwoorden ─────────────────────────────────────────────────────
// Per allergeen een lijst Nederlandse ingrediënt-termen. Matchen op
// woord-grenzen (case-insensitive) om false positives te vermijden
// (bv. "boter" in "boterbloem" matcht niet via word boundary).
// Excludes vangt expliciete tegenvoorbeelden af (rijstmelk → géén Melk).
const ALLERGEN_KEYWORDS = {
  'Gluten': {
    include: ['tarwe','tarwemeel','bloem','bakmeel','brood','broodkruim','paneermeel','beschuit','crouton','pasta','noedel','noedels','spaghetti','tagliatelle','penne','farfalle','macaroni','lasagne','ravioli','gnocchi','couscous','bulgur','semolina','griesmeel','spelt','kamut','rogge','roggebrood','gerst','gort','haver','havermout','seitan','crackers','filodeeg','bladerdeeg','phyllo','soja saus','sojasaus','ketjap','biscuits','koekjes','cake','baguette','panini','pita','tortilla','wrap'],
    exclude: [],
  },
  'Schaaldieren': {
    include: ['garnaal','garnalen','scampi','langoustine','kreeft','krab','rivierkreeft','noordzeegarnaal','noordzeegarnalen','reuzengarnaal','reuzengarnalen','grijze garnaal','grijze garnalen','crevette'],
    exclude: [],
  },
  'Eieren': {
    include: ['ei','eieren','eigeel','eidooier','eiwit','eipoeder','kwartelei','kwarteleieren','mayonaise','hollandaise','bearnaise','aioli','meringue','custard','pasta verse','tagliatelle verse'],
    exclude: [],
  },
  'Vis': {
    include: ['vis','tonijn','zalm','kabeljauw','schol','tong','wijting','schelvis','heilbot','heek','makreel','haring','sardine','sardines','ansjovis','forel','snoekbaars','baars','poon','rode poon','zeewolf','zeebaars','zeebrasem','dorade','rog','victoriabaars','pangasius','vissaus','worcestershire','worchestershire','worcester','worchester','surimi','viskuit','kaviaar','bottarga'],
    exclude: [],
  },
  'Pindas': {
    include: ['pinda','pindas','pindakaas','pindasaus','satésaus','sate saus','aardnoot','arachide'],
    exclude: [],
  },
  'Soja': {
    include: ['soja','sojaboon','sojabonen','sojasaus','soja saus','ketjap','edamame','tofu','tempeh','miso','sojamelk','sojayoghurt','sojaroom','tahoe','tahini'],
    exclude: [],
  },
  'Melk': {
    include: ['melk','volle melk','halfvolle melk','magere melk','karnemelk','room','slagroom','zure room','crème fraîche','creme fraiche','mascarpone','ricotta','mozzarella','parmezaan','parmigiano','grana padano','pecorino','gorgonzola','brie','camembert','cheddar','feta','geitenkaas','schapenkaas','kaas','boter','ghee','yoghurt','kwark','hangop','kefir','zuivel','melkpoeder','condens','condensmelk','ijs','vanille-ijs','roomijs','custard','butterkaas','smeerkaas','huttenkase'],
    exclude: ['rijstmelk','sojamelk','amandelmelk','kokosmelk','havermelk','olijfboter','pindakaas','botersla','boterbloem'],
  },
  'Noten': {
    include: ['amandel','amandelen','amandelmeel','amandelschaafsel','hazelnoot','hazelnoten','walnoot','walnoten','cashew','cashewnoten','pecan','pecannoten','paranoot','paranoten','pistache','pistaches','macadamia','marsepein','nougat','praline','noten','notenmix','pijnboompit','pijnboompitten'],
    exclude: ['nootmuskaat','kokosnoot','muskaatnoot'],
  },
  'Selderij': {
    include: ['selderij','bleekselderij','knolselderij','selderie','bleekselderie','knolselderie','seldersnijbleek'],
    exclude: [],
  },
  'Mosterd': {
    include: ['mosterd','mosterdzaad','mosterdpoeder','dijon','grove mosterd'],
    exclude: [],
  },
  'Sesamzaad': {
    include: ['sesam','sesamzaad','sesamolie','tahini','tahin','gomashio','halva'],
    exclude: [],
  },
  'Zwaveldioxide': {
    include: ['wijn','witte wijn','rode wijn','rosé','rose','port','rode port','witte port','sherry','marsala','vermouth','noilly prat','madeira','azijn','rode wijnazijn','witte wijnazijn','balsamico','balsamicoazijn','gedroogd fruit','rozijnen','krenten','abrikozen gedroogd','vijgen gedroogd','dadels'],
    exclude: ['rijstazijn','appelazijn'],
  },
  'Lupine': {
    include: ['lupine','lupinebonen','lupinemeel'],
    exclude: [],
  },
  'Weekdieren': {
    include: ['mossel','mosselen','mosselvlees','oester','oesters','inktvis','calamares','calamari','octopus','sint-jakobsschelp','sint jakobsschelp','jakobsschelp','coquille','coquilles','venusschelp','wulk','slak','escargot','kokkel','kokkels'],
    exclude: [],
  },
};

// Detecteer welke allergenen aanwezig zijn op basis van ingrediëntlijst
function detectAllergenen(ingredients) {
  if (!Array.isArray(ingredients) || ingredients.length === 0) return [];
  // Verzamel alle ingrediëntnamen tot één doorzoekbare tekst (lowercase, accenten verwijderd)
  const normalize = (s) => (s||'')
    .toLowerCase()
    .normalize('NFD').replace(/[\u0300-\u036f]/g, '') // verwijder diacritics: é→e
    .replace(/\s+/g, ' ')
    .trim();
  const text = ingredients.map(i => normalize(i.name)).join(' | ');
  const detected = [];
  for (const [allergeen, {include, exclude}] of Object.entries(ALLERGEN_KEYWORDS)) {
    // Eerst checken op exclusies: als een excl-term voorkomt, deze allergeen overslaan
    // (alleen als de excl-term feitelijk overlapt met een include-match scenario)
    const excludeMatched = exclude.some(term => {
      const t = normalize(term);
      return new RegExp(`\\b${t.replace(/[.*+?^${}()|[\\]\\\\]/g, '\\\\$&')}\\b`).test(text);
    });
    // Match include — exclude wint alleen als het exact dezelfde positie zou treffen
    let found = false;
    for (const term of include) {
      const t = normalize(term);
      const re = new RegExp(`\\b${t.replace(/[.*+?^${}()|[\\]\\\\]/g, '\\\\$&')}\\b`);
      if (re.test(text)) { found = true; break; }
    }
    if (found && !excludeMatched) detected.push(allergeen);
    else if (found && excludeMatched) {
      // Tricky case: zowel "melk" als "rijstmelk" kan voorkomen. Check of er een
      // include-match is die NIET binnen een exclude-context valt.
      const cleanText = exclude.reduce((acc, ex) => acc.replace(new RegExp(`\\b${normalize(ex)}\\b`, 'g'), ' '), text);
      for (const term of include) {
        const t = normalize(term);
        const re = new RegExp(`\\b${t.replace(/[.*+?^${}()|[\\]\\\\]/g, '\\\\$&')}\\b`);
        if (re.test(cleanText)) { detected.push(allergeen); break; }
      }
    }
  }

  // ── Sub-allergenen voor Gluten en Noten ──────────────────────────────
  // Als Gluten/Noten gedetecteerd is, kijk of we de specifieke soort kunnen
  // identificeren. Default = niets toevoegen als we het niet zeker weten.
  const subDetect = (mapping) => {
    const found = [];
    for (const [sub, terms] of Object.entries(mapping)) {
      for (const term of terms) {
        const t = normalize(term);
        const re = new RegExp(`\\b${t.replace(/[.*+?^${}()|[\\]\\\\]/g, '\\\\$&')}\\b`);
        if (re.test(text)) { found.push(sub); break; }
      }
    }
    return found;
  };

  if (detected.includes('Gluten')) {
    const subs = subDetect({
      'Tarwe':  ['tarwe','tarwemeel','bloem','bakmeel','bloem patent','semolina','griesmeel','spelt','kamut','brood','broodkruim','paneermeel','beschuit','crouton','pasta','noedel','noedels','spaghetti','tagliatelle','penne','farfalle','macaroni','lasagne','ravioli','gnocchi','couscous','bulgur','seitan','filodeeg','bladerdeeg','phyllo','crackers','koekjes','biscuits','cake','baguette','panini','pita','tortilla','wrap'],
      'Rogge':  ['rogge','roggebrood','roggemeel'],
      'Gerst':  ['gerst','gort','parelgort','gerstemout','mout'],
      'Haver':  ['haver','havermout','havervlokken'],
    });
    detected.push(...subs);
  }

  if (detected.includes('Noten')) {
    const subs = subDetect({
      'Amandelen':    ['amandel','amandelen','amandelmeel','amandelschaafsel','marsepein','nougat','praline'],
      'Hazelnoten':   ['hazelnoot','hazelnoten','nutella'],
      'Walnoten':     ['walnoot','walnoten','okkernoot'],
      'Cashewnoten':  ['cashew','cashewnoten'],
      'Pecannoten':   ['pecan','pecannoten'],
      'Paranoten':    ['paranoot','paranoten'],
      'Pistachenoten':['pistache','pistaches','pistachenoot','pistachenoten'],
      'Macadamianoten':['macadamia','macadamianoot','macadamianoten'],
    });
    detected.push(...subs);
  }

  return detected;
}
const GLUTEN_SUB = ['Tarwe','Rogge','Gerst','Haver'];
const NOTEN_SUB  = ['Amandelen','Hazelnoten','Walnoten','Cashewnoten','Pecannoten','Paranoten','Pistachenoten','Macadamianoten'];
const uid = () => Date.now() + Math.floor(Math.random() * 10000);

// ── ISO 8601 week helpers ─────────────────────────────────────────────────────
// Een week start op maandag; week 1 is de week met de eerste donderdag
// van het jaar. Een jaar kan 52 of 53 weken hebben. Begin januari kan tot
// week 52/53 van het voorgaande jaar horen, en omgekeerd.
function isoWeekOf(date) {
  const d = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()));
  d.setUTCDate(d.getUTCDate() + 4 - (d.getUTCDay() || 7));
  const yearStart = new Date(Date.UTC(d.getUTCFullYear(), 0, 1));
  const week = Math.ceil((((d - yearStart) / 86400000) + 1) / 7);
  return { year: d.getUTCFullYear(), week };
}

// Bereken een Date-object voor (dayIdx in week) + weekOffset relatief aan vandaag.
function targetDate(dayIdx, weekOffset = 0) {
  const now = new Date();
  const currentDayIdx = now.getDay() === 0 ? 6 : now.getDay() - 1;
  const t = new Date(now);
  t.setDate(t.getDate() + (dayIdx - currentDayIdx + weekOffset * 7));
  return t;
}

// dayKey: absolute identifier voor een specifieke kalenderdag.
// Format: "YYYY-Www-Dd"  bijv. "2026-W20-Wo"
// Stabiel: wijzigt niet bij overgang van de ene naar de andere week.
const dayKey = (dayName, weekOffset = 0) => {
  const dayIdx = DAYS.indexOf(dayName);
  if (dayIdx < 0) return dayName;
  const { year, week } = isoWeekOf(targetDate(dayIdx, weekOffset));
  return `${year}-W${String(week).padStart(2, '0')}-${dayName}`;
};

// Get actual date for a day index + weekOffset
function getDayDate(dayIdx, weekOffset=0) {
  const now = new Date();
  const currentDayIdx = now.getDay() === 0 ? 6 : now.getDay() - 1;
  const diff = dayIdx - currentDayIdx + (weekOffset * 7);
  const d = new Date(now);
  d.setDate(d.getDate() + diff);
  return d.getDate();
}

function getWeekLabel(weekOffset=0) {
  const now = new Date();
  const currentDayIdx = now.getDay() === 0 ? 6 : now.getDay() - 1;
  const monday = new Date(now);
  monday.setDate(monday.getDate() - currentDayIdx + (weekOffset * 7));
  const sunday = new Date(monday);
  sunday.setDate(monday.getDate() + 6);
  const months = ['jan','feb','mrt','apr','mei','jun','jul','aug','sep','okt','nov','dec'];
  return `${monday.getDate()} ${months[monday.getMonth()]} – ${sunday.getDate()} ${months[sunday.getMonth()]}`;
}

// Get week number (ISO 8601 correct)
function getWeekNr(weekOffset=0) {
  const now = new Date();
  const d = new Date(now);
  d.setDate(d.getDate() + (weekOffset * 7));
  return isoWeekOf(d).week;
}

// ── WPRM helpers ──────────────────────────────────────────────────────────────
function norm(s) { return s.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g,'').replace(/[^a-z0-9 ]/g,' ').replace(/\s+/g,' ').trim(); }


// ── Supabase config ───────────────────────────────────────────────────────────
// ══════════════════════════════════════════════════════════════════════════════
// ██  CONFIGURATIE — pas dit blok aan per bedrijf/locatie  ██
// ══════════════════════════════════════════════════════════════════════════════
const CONFIG = {
  bedrijfsnaam: 'BijHENC',           // Naam die bovenaan de app verschijnt
  logoUrl: '',                        // URL naar logo (leeg = alleen tekst)
  accentKleur: '#C9A84C',            // Goud — hoofdaccent
  accentLicht: '#FDF6E3',            // Lichte goudtint
  accentBorder: '#E2C97E',           // Goud border
  supabaseUrl: 'https://vpglnmtyylndndmmsapk.supabase.co',
  supabaseKey: 'sb_publishable_EZnydh51ozAuYWigEi5o2A_owNgGjB6',
  printServerUrl: 'https://print.bijhenc.nl', // Cloudflare Tunnel
};
// ══════════════════════════════════════════════════════════════════════════════

const SB_URL = CONFIG.supabaseUrl;
const SB_KEY = CONFIG.supabaseKey;
const SB_HDR = { apikey: SB_KEY, Authorization: `Bearer ${SB_KEY}`, 'Content-Type': 'application/json' };

async function sbLoad() {
  try {
    const r = await fetch(`${SB_URL}/rest/v1/mep_data?id=eq.1&select=data`, { headers: SB_HDR });
    const rows = await r.json();
    if (rows?.length && rows[0]?.data?.depts?.length) return rows[0].data;
  } catch(e) { console.warn('Supabase load failed:', e); }
  return null;
}

async function sbSave(state) {
  try {
    const r = await fetch(`${SB_URL}/rest/v1/mep_data?id=eq.1`, {
      method: 'PATCH',
      headers: {...SB_HDR, Prefer: 'return=minimal'},
      body: JSON.stringify({ data: state, updated_at: new Date().toISOString() })
    });
    if (!r.ok) console.warn('Supabase save error:', r.status, await r.text());
  } catch(e) { console.warn('Supabase save failed:', e); }
}

// ── Initial state ─────────────────────────────────────────────────────────────
const mkDept = (name) => ({
  id:'dept-'+uid(), name,
  items:[]
});

const loadState = () => {
  try {
    const s = localStorage.getItem('mep-v2');
    if (s) { const p=JSON.parse(s); if(p.depts&&p.depts.length) return p; }
  } catch {}
  const d = mkDept('Warme kant');
  return { depts:[d], activeDept:d.id };
};

// ── Color tokens ──────────────────────────────────────────────────────────────
const C = {
  bg:'#F0F4FF',       // lichtblauw paginaachtergrond
  bg2:'#FFFFFF',      // kaarten / tabel
  bg3:'#E4ECFF',      // categorie rijen / subtiele vlakken
  hdr:'#0C1835',      // navy header
  hdrBdr:'#1A2D5A',   // navy border
  txt:'#0C1835',      // primaire tekst — navy
  txt2:'#4A5D8A',     // secundaire tekst
  txt3:'#8FA0C0',     // placeholder / lege staat
  bdr:'#BCCEFB',      // lichtblauw border
  bdr2:'#90ACEF',     // hover border
  amber:CONFIG.accentKleur, amberBg:CONFIG.accentLicht, amberBd:CONFIG.accentBorder,
  green:'#1E7A3A', greenBg:'#E6F5EC', greenBd:'#86CCA0',
  red:'#B03030', redBg:'#FFE9E9', redBd:'#F0AAAA',
  today:'#BCCEFB', todayBd:'#4A6FCB', todayTxt:'#0C1835',
};

// ── Receptenboek helpers (Fase 1) ─────────────────────────────────────────────
// Velden die naar het 'recipe'-object verhuizen bij splitsing van een item.
// De rest (planning, archief, recipe_id) blijft op het item zelf.
const RECIPE_FIELDS = ['name', 'category', 'recipe', 'ingredients', 'allergenen', 'tht_dagen', 'bewaaradvies'];

// Migreer v2 → v3: splits item-eigen recept-data af naar de recipes-bibliotheek.
// Items met inhoud krijgen een recipe_id; bestaande recipe-velden op het item
// blijven aanwezig (legacy compat) maar de bibliotheek wordt de bron van waarheid.
function migrateToRecipeBook(state) {
  const recipes = Array.isArray(state.recipes) ? [...state.recipes] : [];
  let recipeIdCounter = recipes.reduce((m, r) => Math.max(m, r.id || 0), 0);

  const newDepts = (state.depts || []).map(d => ({
    ...d,
    items: (d.items || []).map(it => {
      if (it.recipe_id) return it; // al gekoppeld, niets te doen

      // Heeft dit item recept-achtige data? Dan splitsen we het af.
      const hasContent =
        (it.recipe && it.recipe.trim()) ||
        (Array.isArray(it.ingredients) && it.ingredients.length > 0) ||
        (Array.isArray(it.allergenen)  && it.allergenen.length  > 0);

      if (!hasContent && !it.name) return it;

      const recipe = {
        id: ++recipeIdCounter,
        name:        it.name        || '(naamloos)',
        category:    it.category    || '',
        recipe:      it.recipe      || '',
        ingredients: it.ingredients || [],
        allergenen:  it.allergenen  || [],
        tht_dagen:   it.tht_dagen,
        bewaaradvies:it.bewaaradvies,
        archived:    false,
        _createdAt:  new Date().toISOString(),
      };
      recipes.push(recipe);

      return { ...it, recipe_id: recipe.id };
    })
  }));

  return { ...state, depts: newDepts, recipes, _schemaVersion: 3 };
}

// ── App ───────────────────────────────────────────────────────────────────────
export default function App() {
  const [depts,      setDepts]      = useState(() => loadState().depts);
  const [activeDept, setActiveDept] = useState(() => {
    // Eigen localStorage-key zodat dit per device onafhankelijk is van
    // de gesynchroniseerde data. Fallback op de eerste afdeling uit cache.
    try {
      const saved = localStorage.getItem('mep-active-dept');
      if (saved) return saved;
    } catch {}
    return loadState().activeDept;
  });
  const [view,       setView]       = useState('mep');
  const [selId,      setSelId]      = useState(null);
  const [editing,    setEditing]    = useState(false);
  const [draft,      setDraft]      = useState(null);
  const [addingItem, setAddingItem] = useState(false);
  const [newForm,    setNewForm]    = useState({name:'',category:'Vlees'});
  const [addingDept,  setAddingDept]  = useState(false);
  const [customCats,    setCustomCats]    = useState([]);
  const [medewerkers,   setMedewerkers]   = useState([]);
  const [addingMed,     setAddingMed]     = useState(false);
  const [showMedewerkersModal, setShowMedewerkersModal] = useState(false);
  const [urenMedewerker, setUrenMedewerker] = useState(null);  // medewerker.id van geopende uren-modal
  const [urenWeekOffset, setUrenWeekOffset] = useState(0);      // welke week we in de uren-modal tonen
  const [newMedNaam,    setNewMedNaam]    = useState('');
  const [addingCat,   setAddingCat]   = useState(false);
  const [newCatName,  setNewCatName]  = useState('');
  const [newDeptName,setNewDeptName]= useState('');
  const [pasteMode,    setPasteMode]    = useState(false);
  const [pasteText,    setPasteText]    = useState('');
  const [showArchive,  setShowArchive]  = useState(false);
  const [skipItems,  setSkipItems]  = useState(new Set());
  const [recipes,    setRecipes]    = useState([]);  // Receptenboek bibliotheek (fase 1)
  const [selRecipeId, setSelRecipeId] = useState(null);  // Geselecteerd recept in bibliotheek
  const [recipeDraft, setRecipeDraft] = useState(null);  // Bewerk-draft voor recept
  const [recipeEditing, setRecipeEditing] = useState(false);
  const [recipeSearch,  setRecipeSearch]  = useState('');
  const [recipeCatFilter, setRecipeCatFilter] = useState('alle');
  const [recipeShowArchived, setRecipeShowArchived] = useState(false);
  const [showCatManager, setShowCatManager] = useState(false);
  const [newCatInManager, setNewCatInManager] = useState('');
  const [hideChecked, setHideChecked] = useState(false);
  const [swipeState, setSwipeState] = useState({});
  const [printMode,    setPrintMode]    = useState(false);
  const [selectedDay,  setSelectedDay]  = useState(dayKey(DAYS[todayIdx], 0));
  const [weekOffset,   setWeekOffset]   = useState(0);
  const [checklists,   setChecklists]   = useState({opstart:[],afsluiting:[]});
  const [checkDone,    setCheckDone]    = useState({}); // {id: true} resets daily
  const [checkDate,    setCheckDate]    = useState(''); // tracks current date // 0=deze week, 1=volgende week, -1=vorige week
  const [printEtiket,  setPrintEtiket]  = useState(false);
  const [showInfo,     setShowInfo]     = useState(false);
  const [sidebarOpen,  setSidebarOpen]  = useState(false);
  const [searchQuery,  setSearchQuery]  = useState('');
  const [searchOpen,   setSearchOpen]   = useState(false);
  const [undoItem,     setUndoItem]     = useState(null); // {id, day, prevState, name}
  const [undoTimer,    setUndoTimer]    = useState(null);
  const [showCalc,     setShowCalc]     = useState(false);
  const [calcVal,      setCalcVal]      = useState('0');
  const [calcPrev,     setCalcPrev]     = useState(null);
  const [calcOp,       setCalcOp]       = useState(null);
  const [calcNew,      setCalcNew]      = useState(true);
  const [showKladblok, setShowKladblok] = useState(false);
  const [kladblok,     setKladblok]     = useState({}); // {deptId_date: text}
  const [glutenOpen,   setGlutenOpen]   = useState(false);
  const [notenOpen,    setNotenOpen]    = useState(false);
  const [recipeGlutenOpen, setRecipeGlutenOpen] = useState(false);
  const [recipeNotenOpen,  setRecipeNotenOpen]  = useState(false);
  const [printerStatus, setPrinterStatus] = useState(null); // null=onbekend, true=online, false=offline
  const [etikMed,      setEtikMed]      = useState('');
  const [etikExtra,    setEtikExtra]    = useState(0);
  const [etikProdDatum, setEtikProdDatum] = useState('');  // YYYY-MM-DD; leeg = vandaag

  // ── Persistence ─────────────────────────────────────────────────────────────
  const [synced, setSynced] = useState(false);
  const [syncing, setSyncing] = useState(false);

  // Load from Supabase on mount, fallback to localStorage
  // ── State applicatie helper (DRY: gebruikt door load + polling) ────────────
  // Note: activeDept wordt hier bewust niet onvoorwaardelijk gezet. Elke
  // gebruiker heeft zijn eigen voorkeur per device. We zetten 'm alleen als
  // de huidige selectie niet (meer) bestaat in de geladen depts.
  // initialLoad=true betekent: dit is de eerste load, accepteer ook lege arrays
  // (anders kun je nooit van gevulde naar lege state). false (polling) betekent:
  // lege arrays vanuit remote NIET toepassen op een lokaal gevulde state, dat
  // is bijna altijd een race-condition van een ander device.
  const applyRemoteState = (src, initialLoad = false) => {
    if (!src) return;
    if (src.depts?.length) {
      setDepts(src.depts);
      setActiveDept(prev => {
        if (prev && src.depts.some(d => d.id === prev)) return prev;
        return src.depts[0].id;
      });
    }
    if (src.customCats?.length) setCustomCats(src.customCats);
    if (src.medewerkers?.length) setMedewerkers(src.medewerkers);
    if (src.checklists) setChecklists(src.checklists);
    if (src.kladblok) setKladblok(src.kladblok);
    if (Array.isArray(src.skipItems)) setSkipItems(new Set(src.skipItems));
    // Recipes: bij initial load altijd accepteren (ook leeg).
    // Bij polling: alleen toepassen als remote gevuld is, om te voorkomen dat
    // een ander device met race-condition onze lokale gevulde recipes wist.
    if (Array.isArray(src.recipes)) {
      if (initialLoad || src.recipes.length > 0) {
        setRecipes(src.recipes);
      }
      // anders: behoud lokale recipes, negeer lege remote
    }
  };

  // Tracker voor onze eigen meest recente save zodat we onze eigen
  // echo's bij polling kunnen negeren
  const lastSaveAtRef = useRef(null);

  // Initial load: probeer remote, anders lokale cache als snelle fallback
  useEffect(() => {
    (async () => {
      const remote = await sbLoad();

      // ── Automatische migratie v2 → v3 is uitgeschakeld ────────────────────
      // De gebruiker beheert het Receptenboek voortaan handmatig. Bestaande
      // items in de MEP-lijst behouden hun legacy recept-velden (name, recipe,
      // ingredients, allergenen) en blijven werken zoals voorheen. Recipes is
      // een aparte bibliotheek waar nieuwe recepten via "+ Nieuw recept"
      // (plakken of leeg) worden toegevoegd.

      if (remote?.depts?.length) {
        applyRemoteState(remote, true);  // initialLoad=true
        lastSaveAtRef.current = remote._savedAt || null;
      } else {
        // Geen remote → gebruik lokale cache als noodval (offline first start)
        try {
          const raw = localStorage.getItem('mep-v2');
          if (raw) {
            const local = JSON.parse(raw);
            if (local?.depts?.length) applyRemoteState(local, true);
          }
        } catch {}
      }
      setSynced(true);
    })();
  }, []);

  // ── Save to Supabase + localStorage on change (debounced) ──────────────────
  // Note: activeDept zit hier bewust NIET in — dat is UI-state (welke tab
  // bekijk je) en moet per device onafhankelijk blijven. Hij wordt apart
  // gepersisteerd in localStorage onder zijn eigen key.
  // Veiligheid: vóór elke save fetchen we de remote staat. Als die nieuwer is
  // dan wat wij ooit zagen, schrijven we NIET en passen we eerst de remote toe.
  // Dit voorkomt dat een oude tab een nieuwere staat van een ander device
  // overschrijft (klassieke race-condition bij multi-device sync).
  useEffect(() => {
    if (!synced) return;
    const savedAt = new Date().toISOString();
    const state = {
      depts, customCats, medewerkers, checklists, kladblok,
      skipItems: [...skipItems],
      recipes,
      _schemaVersion: 3,
      _savedAt: savedAt,
    };
    try { localStorage.setItem('mep-v2', JSON.stringify(state)); } catch {}
    setSyncing(true);
    const t = setTimeout(async () => {
      // Versie-check: lees remote, vergelijk met wat wij laatst zagen
      try {
        const remote = await sbLoad();
        const remoteAt = remote?._savedAt;
        const ourLastKnown = lastSaveAtRef.current;
        if (remoteAt && ourLastKnown && remoteAt > ourLastKnown) {
          // Remote is nieuwer dan onze laatste bekende → ander device heeft
          // intussen geschreven. Niet overschrijven; pas eerst remote toe.
          console.warn('Save afgebroken: remote bevat nieuwere data van ander device. Toepassen remote.');
          applyRemoteState(remote, false);
          lastSaveAtRef.current = remoteAt;
          setSyncing(false);
          return;
        }
      } catch (e) {
        // Bij netwerkfout op de check: doorgaan met save (offline-tolerant)
      }
      await sbSave(state);
      lastSaveAtRef.current = savedAt; // onthoud zodat polling geen echo terugleest
      setSyncing(false);
    }, 1200);
    return () => clearTimeout(t);
  }, [depts, customCats, medewerkers, checklists, kladblok, skipItems, recipes, synced]);

  // ── activeDept apart bewaren in localStorage (per device, niet gesynct) ───
  useEffect(() => {
    if (!activeDept) return;
    try { localStorage.setItem('mep-active-dept', activeDept); } catch {}
  }, [activeDept]);

  // ── Polling: haal remote elke 5s op, alleen bij zichtbare tab ──────────────
  // Plus directe refresh bij window focus / visibility change zodat je nooit
  // langer dan een blik op stale data zit.
  useEffect(() => {
    if (!synced) return;

    let cancelled = false;

    const pullAndApply = async () => {
      if (document.hidden) return;
      const remote = await sbLoad();
      if (cancelled || !remote?.depts?.length) return;
      // Negeer als deze remote-versie van onze eigen recente save komt
      if (remote._savedAt && remote._savedAt === lastSaveAtRef.current) return;
      // Negeer als we momenteel zelf aan het saven zijn (debounce pending)
      if (syncing) return;
      applyRemoteState(remote);
      lastSaveAtRef.current = remote._savedAt || null;
    };

    const intervalId = setInterval(pullAndApply, 5000);

    const onVisible = () => { if (!document.hidden) pullAndApply(); };
    const onFocus   = () => pullAndApply();
    document.addEventListener('visibilitychange', onVisible);
    window.addEventListener('focus', onFocus);

    return () => {
      cancelled = true;
      clearInterval(intervalId);
      document.removeEventListener('visibilitychange', onVisible);
      window.removeEventListener('focus', onFocus);
    };
  }, [synced, syncing]);

  // ── Auto-detectie van allergenen in recipeDraft ───────────────────────────
  // Bij wijziging van ingrediënten worden gedetecteerde allergenen automatisch
  // bijgevuld. Door de gebruiker handmatig toegevoegde allergenen (zoals
  // Lupine of Sesamzaad die in een ingrediënt niet als trefwoord voorkomen)
  // blijven behouden. Auto-allergenen kunnen handmatig weer uitgevinkt worden;
  // ze keren niet terug bij elke ingrediënt-wijziging.
  useEffect(() => {
    if (!recipeDraft || !recipeEditing) return;
    const detected = detectAllergenen(recipeDraft.ingredients || []);
    if (detected.length === 0) return;
    setRecipeDraft(d => {
      if (!d) return d;
      const current = new Set(d.allergenen || []);
      let changed = false;
      for (const a of detected) {
        if (!current.has(a)) { current.add(a); changed = true; }
      }
      return changed ? {...d, allergenen: [...current]} : d;
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [recipeEditing, recipeDraft?.ingredients]);

  // ── Printer status polling ───────────────────────────────────────────────────
  useEffect(() => {
    const checkPrinter = async () => {
      if (!CONFIG.printServerUrl || CONFIG.printServerUrl.includes('NGROK_URL_HIER')) return;
      try {
        const r = await fetch(`${CONFIG.printServerUrl}/status`, { signal: AbortSignal.timeout(3000) });
        const d = await r.json();
        setPrinterStatus(d.printerOnline !== false);
      } catch { setPrinterStatus(false); }
    };
    checkPrinter();
    const interval = setInterval(checkPrinter, 30000); // elke 30 seconden
    return () => clearInterval(interval);
  }, []);

  // ── Daily reset voor checklist vinkjes ──────────────────────────────────────
  useEffect(() => {
    const today = new Date().toDateString();
    const stored = localStorage.getItem('mep-checkdone');
    const stored_date = localStorage.getItem('mep-checkdate');
    if (stored_date === today && stored) {
      setCheckDone(JSON.parse(stored));
    } else {
      // New day - reset all
      setCheckDone({});
      localStorage.setItem('mep-checkdate', today);
      localStorage.setItem('mep-checkdone', '{}');
    }
    setCheckDate(today);
  }, []);

  const toggleCheckDone = (id) => {
    setCheckDone(prev => {
      const next = {...prev, [id]: !prev[id]};
      localStorage.setItem('mep-checkdone', JSON.stringify(next));
      return next;
    });
  };


  // ── Derived ─────────────────────────────────────────────────────────────────
  const dept     = depts.find(d=>d.id===activeDept) || depts[0] || loadState().depts[0];
  const allCats  = [...CAT_ORDER.filter(c => c !== 'Overig'), ...customCats, 'Overig'];

  // ── enrichItem: koppelt recept-inhoud aan een item ───────────────────────
  // Als een item een recipe_id heeft, neemt het de recept-inhoud over
  // (recept-tekst, ingrediënten, allergenen, tht, bewaaradvies) maar BEHOUDT
  // zijn eigen naam, categorie en planning (checks, mults, notes, archived).
  const recipeById = (id) => recipes.find(r => r.id === id);
  const enrichItem = (item) => {
    if (!item) return item;
    if (!item.recipe_id) return item; // geen koppeling → item zoals het is
    const recipe = recipeById(item.recipe_id);
    if (!recipe) return item; // gekoppeld recept bestaat niet meer → laat item met rust
    // Recept levert de INHOUD; item behoudt eigen naam, categorie en planning.
    return {
      ...item,
      recipe:       recipe.recipe,
      ingredients:  recipe.ingredients,
      allergenen:   recipe.allergenen,
      tht_dagen:    recipe.tht_dagen,
      bewaaradvies: recipe.bewaaradvies,
      _recipeName:  recipe.name,  // referentie naar bron-recept (voor UI)
    };
  };

  const items    = (dept?.items || []).map(enrichItem);

  const selItem  = items.find(i=>i.id===selId);
  const cur      = editing ? draft : selItem;

  // ── Dept helpers ────────────────────────────────────────────────────────────
  const updDept = (id,fn) => setDepts(ds=>ds.map(d=>d.id===id?fn(d):d));
  const addDept = () => {
    if (!newDeptName.trim()) return;
    const d=mkDept(newDeptName.trim());
    setDepts(p=>[...p,d]); setActiveDept(d.id); setNewDeptName(''); setAddingDept(false);
  };
  const delDept = (id) => {
    if (depts.length<=1) { alert('Minimaal één afdeling vereist.'); return; }
    if (!window.confirm(`Afdeling verwijderen? Alle items gaan verloren.`)) return;
    const remaining=depts.filter(d=>d.id!==id);
    setDepts(remaining); setActiveDept(remaining[0].id);
  };


  // ── Item helpers ─────────────────────────────────────────────────────────────
  const updItems  = fn => updDept(dept.id, d=>({...d,items:fn(d.items)}));
  const openItem  = id => { setSelId(id); setEditing(false); setDraft(null); };
  const closePanel= ()  => { setSelId(null); setEditing(false); setDraft(null); };
  // startEdit gebruikt de RAUWE item (uit dept.items) zodat we niet per ongeluk
  // gemergede recept-inhoud als item-eigen velden opslaan.
  const startEdit = ()  => {
    const raw = (dept?.items || []).find(i => i.id === selId) || selItem;
    setDraft(JSON.parse(JSON.stringify(raw)));
    setEditing(true);
  };
  const saveEdit  = ()  => { updItems(its=>its.map(i=>i.id===draft.id?draft:i)); setSelId(draft.id); setEditing(false); setDraft(null); };
  const deleteItem= id  => { if (!window.confirm(`"${selItem?.name}" verwijderen?`)) return; updItems(its=>its.filter(i=>i.id!==id)); closePanel(); };
  const moveItem  = (id, toDeptId) => {
    const item = items.find(i=>i.id===id); if (!item) return;
    updItems(its=>its.filter(i=>i.id!==id));
    setDepts(ds=>ds.map(d=>d.id===toDeptId?{...d,items:[...d.items,{...item,checks:{},mults:{},notes:{}}]}:d));
    closePanel();
  };

  // ── Recipe helpers (Fase 2) ──────────────────────────────────────────────────
  const selRecipe       = recipes.find(r=>r.id===selRecipeId);
  const curRecipe       = recipeEditing ? recipeDraft : selRecipe;
  const openRecipe      = id => { setSelRecipeId(id); setRecipeEditing(false); setRecipeDraft(null); };
  const closeRecipe     = () => { setSelRecipeId(null); setRecipeEditing(false); setRecipeDraft(null); };
  const startEditRecipe = () => { setRecipeDraft(JSON.parse(JSON.stringify(selRecipe))); setRecipeEditing(true); };
  const saveEditRecipe  = () => {
    setRecipes(rs => rs.map(r => r.id === recipeDraft.id ? recipeDraft : r));
    setSelRecipeId(recipeDraft.id);
    setRecipeEditing(false);
    setRecipeDraft(null);
  };
  const addRecipe = (data = {}) => {
    const ingredients = data.ingredients || [];
    // Auto-detect allergenen op basis van ingrediënten + handmatige toevoegingen
    const autoDetected = detectAllergenen(ingredients);
    const manualAllergenen = data.allergenen || [];
    const mergedAllergenen = [...new Set([...manualAllergenen, ...autoDetected])];

    const r = {
      id: uid(),  // Uniek ID (Date.now + random) zodat ID's nooit hergebruikt
                  // worden na verwijderen — voorkomt botsing met oude item-koppelingen
      name: data.name || 'Nieuw recept',
      category: data.category || 'Overig',
      recipe: data.recipe || '',
      ingredients,
      allergenen: mergedAllergenen,
      tht_dagen: data.tht_dagen ?? null,
      bewaaradvies: data.bewaaradvies || '',
      archived: false,
      _createdAt: new Date().toISOString(),
    };
    setRecipes(rs => [...rs, r]);
    return r;
  };
  const archiveRecipe = (id, archived=true) => setRecipes(rs => rs.map(r => r.id===id ? {...r, archived} : r));
  const deleteRecipe = (id) => {
    // Tel alle items (ook gearchiveerd, ook andere parties) die dit recept koppelen
    let linkedCount = 0;
    depts.forEach(d => d.items.forEach(it => { if (it.recipe_id === id) linkedCount++; }));

    const naam = recipes.find(r=>r.id===id)?.name || 'dit recept';
    let msg = `"${naam}" definitief verwijderen?`;
    if (linkedCount > 0) {
      msg += `\n\nDit recept is gekoppeld aan ${linkedCount} item(s) in de MEP-lijst. Die items blijven bestaan maar worden ontkoppeld (vallen terug op eigen inhoud).`;
    }
    if (!window.confirm(msg)) return;

    // Ontkoppel alle items die naar dit recept verwijzen
    if (linkedCount > 0) {
      setDepts(ds => ds.map(d => ({
        ...d,
        items: d.items.map(it => it.recipe_id === id ? (() => { const { recipe_id, ...rest } = it; return rest; })() : it)
      })));
    }
    setRecipes(rs => rs.filter(r => r.id !== id));
    closeRecipe();
  };
  // Plan een recept in op een afdeling (maakt een lijst-item met recipe_id)
  const planRecipeOnDept = (recipeId, deptId) => {
    const r = recipes.find(x => x.id === recipeId);
    if (!r) return;
    const newItem = { id: uid(), recipe_id: recipeId, checks: {}, mults: {}, notes: {} };
    setDepts(ds => ds.map(d => d.id === deptId
      ? { ...d, items: [...d.items, newItem] }
      : d
    ));
  };

  // ── Uren-registratie helpers ─────────────────────────────────────────────────
  // Bereken gewerkte uren voor één dag (in decimale uren, afgerond op 0.25u)
  const berekenDagUren = (start, eind, pauze=0) => {
    if (!start || !eind) return 0;
    const [sh, sm] = start.split(':').map(Number);
    const [eh, em] = eind.split(':').map(Number);
    if (isNaN(sh) || isNaN(eh)) return 0;
    let minuten = (eh*60 + em) - (sh*60 + sm) - (pauze||0);
    if (minuten < 0) minuten += 24*60; // overnight shift (bv 22:00 → 02:00)
    if (minuten < 0) return 0;
    return Math.round((minuten / 60) * 4) / 4; // afgerond op kwartier
  };

  // Update of voeg een uren-entry toe voor een medewerker op een specifieke dag
  const updateUrenEntry = (medewerkerId, dayKeyVal, partial) => {
    setMedewerkers(ms => ms.map(m => {
      if (m.id !== medewerkerId) return m;
      const uren = Array.isArray(m.uren) ? [...m.uren] : [];
      const idx = uren.findIndex(u => u.dayKey === dayKeyVal);
      if (idx >= 0) {
        // Update bestaand record
        const updated = { ...uren[idx], ...partial };
        // Verwijder record als start én eind beide leeg zijn
        if (!updated.start && !updated.eind) {
          uren.splice(idx, 1);
        } else {
          uren[idx] = updated;
        }
      } else {
        // Nieuw record
        const nieuw = { dayKey: dayKeyVal, start: '', eind: '', pauze: 30, ...partial };
        if (nieuw.start || nieuw.eind) {
          uren.push(nieuw);
        }
      }
      return { ...m, uren };
    }));
  };

  // Haal alle dayKeys op voor een gegeven week-offset (Ma t/m Zo)
  const weekDayKeysFor = (offset) => DAYS.map(d => dayKey(d, offset));

  // Tel totaal uren in een week voor een medewerker
  const weekTotaalUren = (medewerker, offset) => {
    const keys = weekDayKeysFor(offset);
    return (medewerker.uren || [])
      .filter(u => keys.includes(u.dayKey))
      .reduce((sum, u) => sum + berekenDagUren(u.start, u.eind, u.pauze||0), 0);
  };

  // Genereer CSV voor de huidige uren-weekoffset
  const downloadWeekrapport = (offset) => {
    const keys = weekDayKeysFor(offset);
    const wkInfo = isoWeekOf(targetDate(0, offset));
    const filename = `uren-week${String(wkInfo.week).padStart(2,'0')}-${wkInfo.year}.csv`;
    // Header
    const lines = [['Medewerker', ...DAYS, 'Totaal'].join(',')];
    // Data per medewerker
    medewerkers.forEach(m => {
      const row = [m.naam];
      let totaal = 0;
      keys.forEach(dk => {
        const entry = (m.uren || []).find(u => u.dayKey === dk);
        const u = entry ? berekenDagUren(entry.start, entry.eind, entry.pauze||0) : 0;
        totaal += u;
        row.push(u.toFixed(2).replace('.', ',')); // NL-decimaal voor Excel-NL
      });
      row.push(totaal.toFixed(2).replace('.', ','));
      lines.push(row.join(','));
    });
    const csv = '\uFEFF' + lines.join('\n'); // BOM voor Excel-NL-compatibiliteit
    const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url; a.download = filename;
    document.body.appendChild(a); a.click();
    document.body.removeChild(a); URL.revokeObjectURL(url);
  };

  // ── Categorie helpers (Fase 2) ───────────────────────────────────────────────
  // Vaste categorieën (CAT_ORDER) kunnen niet verwijderd worden.
  // Custom categorieën kunnen weg; recepten/items in die categorie verhuizen
  // naar 'Overig' (of een door gebruiker gekozen target).
  const isBuiltinCat = (cat) => CAT_ORDER.includes(cat);
  const addCustomCat = (name) => {
    const trimmed = (name||'').trim();
    if (!trimmed || allCats.includes(trimmed)) return false;
    setCustomCats(c => [...c, trimmed]);
    return true;
  };
  const deleteCustomCat = (cat) => {
    if (isBuiltinCat(cat)) {
      window.alert('Standaard categorieën kunnen niet verwijderd worden.');
      return;
    }
    // Tel gebruik
    const recipesInCat = recipes.filter(r => r.category === cat && !r.archived).length;
    const itemsInCat = depts.reduce((n, d) => n + d.items.filter(it => {
      // Item-eigen category of via recipe_id
      if (it.category === cat) return true;
      if (it.recipe_id) {
        const r = recipes.find(x => x.id === it.recipe_id);
        if (r?.category === cat) return true;
      }
      return false;
    }).length, 0);

    let msg = `Categorie "${cat}" verwijderen?`;
    if (recipesInCat > 0 || itemsInCat > 0) {
      msg += `\n\nEr zijn ${recipesInCat} recept(en) en ${itemsInCat} lijst-item(s) in deze categorie. Die verhuizen naar "Overig".`;
    }
    if (!window.confirm(msg)) return;

    // Verhuis recepten en items
    setRecipes(rs => rs.map(r => r.category === cat ? {...r, category: 'Overig'} : r));
    setDepts(ds => ds.map(d => ({
      ...d,
      items: d.items.map(it => it.category === cat ? {...it, category: 'Overig'} : it)
    })));
    setCustomCats(cs => cs.filter(c => c !== cat));
  };
  const archiveItem = id => {
    updItems(its=>its.map(i=>i.id===id?{...i,archived:true,checks:{},mults:{},notes:{}}:i));
    closePanel();
  };
  const restoreItem = id => {
    updItems(its=>its.map(i=>i.id===id?{...i,archived:false}:i));
    closePanel();
  };
  const submitNew = ()  => {
    if (!newForm.name.trim()) return;
    const item={id:uid(),name:newForm.name.trim(),category:newForm.category,recipe:'',ingredients:[],checks:{},mults:{},notes:{},tht_dagen:null,bewaaradvies:'Bewaren onder 7°C',allergenen:[]};
    updItems(its=>[...its,item]); setNewForm({name:'',category:'Vlees'}); setAddingItem(false); openItem(item.id);
  };
  const resetWeek = () => { if (window.confirm('Alle planning resetten voor nieuwe week?')) updItems(its=>its.map(i=>({...i,checks:{},notes:{}}))); };

  // ── Check & doorschuiven ─────────────────────────────────────────────────────
  const toggleCheck = (itemId,day) => {
    const item = items.find(i=>i.id===itemId);
    const prevState = item?.checks?.[day]||0;
    const curState = item?.checks?.[day] || 0;
    const newState = nextCheck(curState);
    if (newState === 2 && item) {
    }
    updItems(its=>its.map(i=>i.id===itemId?{...i,checks:{...i.checks,[day]:newState}}:i));
  };
  const pushDay = (itemId,dayIdx) => {
    const isLast = dayIdx>=DAYS.length-1;
    const nextWeekOffset = isLast ? weekOffset + 1 : weekOffset;
    const nextDayIdx = isLast ? 0 : dayIdx + 1;
    const nextDay = dayKey(DAYS[nextDayIdx], nextWeekOffset);
    const curDay = selectedDay;
    updItems(its=>its.map(i=>{
      if (i.id!==itemId) return i;
      const newChecks={...i.checks};
      const newNotes={...i.notes};
      const newMults={...(i.mults||{})};
      newChecks[nextDay]=Math.max(newChecks[nextDay]||0,1);
      newChecks[curDay]=0;
      if (newNotes[curDay]) { newNotes[nextDay]=newNotes[curDay]; delete newNotes[curDay]; }
      if (newMults[curDay]) { newMults[nextDay]=newMults[curDay]; delete newMults[curDay]; }
      return {...i,checks:newChecks,notes:newNotes,mults:newMults};
    }));
  };


  // ── Bestelbon ────────────────────────────────────────────────────────────────
  const orderList = (() => {
    const map={};
    // Helper: convert dayKey "YYYY-Www-Dd" naar een display date string
    const dayKeyToDate = (dk) => {
      const m = /^(\d{4})-W(\d{2})-(\w+)$/.exec(dk);
      if (!m) return dk;
      const [, yearStr, weekStr, dayName] = m;
      const year = parseInt(yearStr, 10);
      const week = parseInt(weekStr, 10);
      const di = DAYS.indexOf(dayName);
      if (di === -1) return dk;
      // Bereken de maandag van de gegeven ISO-week: 4 januari zit altijd in week 1
      const jan4 = new Date(Date.UTC(year, 0, 4));
      const jan4Day = jan4.getUTCDay() || 7;
      const week1Monday = new Date(jan4);
      week1Monday.setUTCDate(jan4.getUTCDate() - jan4Day + 1);
      const target = new Date(week1Monday);
      target.setUTCDate(week1Monday.getUTCDate() + (week - 1) * 7 + di);
      const months = ['jan','feb','mrt','apr','mei','jun','jul','aug','sep','okt','nov','dec'];
      return `${dayName} ${target.getUTCDate()} ${months[target.getUTCMonth()]}`;
    };
    items.forEach(item=>{
      Object.entries(item.checks||{}).forEach(([dk, st])=>{
        if (st!==1) return;
        const dateLabel = dayKeyToDate(dk);
        item.ingredients.forEach(ing=>{
          if (!ing.name?.trim()) return;
          const k=`${ing.name.trim().toLowerCase()}|${ing.unit}`;
          if (!map[k]) map[k]={name:ing.name.trim(),unit:ing.unit,total:0,supplier:ing.supplier||'Overig',sources:[],dates:[],key:k};
          map[k].total+=(parseFloat(ing.amount)||0);
          if (!map[k].sources.includes(item.name)) map[k].sources.push(item.name);
          if (!map[k].dates.includes(dateLabel)) map[k].dates.push(dateLabel);
        });
      });
    });
    // Sort dates per ingredient
    Object.values(map).forEach(ing => {
      ing.dates.sort((a,b)=>{
        const da=new Date(a.split(' ').slice(1).join(' ')+' '+new Date().getFullYear());
        const db=new Date(b.split(' ').slice(1).join(' ')+' '+new Date().getFullYear());
        return da-db;
      });
    });
    const all=Object.values(map).sort((a,b)=>a.name.localeCompare(b.name,'nl'));
    const bySupplier={};
    all.forEach(i=>{ const s=i.supplier||'Overig'; if(!bySupplier[s]) bySupplier[s]=[]; bySupplier[s].push(i); });
    return {all,bySupplier};
  })();

  const plannedCount=items.reduce((n,i)=>n+Object.values(i.checks).filter(v=>v>0).length,0);

  // ── Table rows ───────────────────────────────────────────────────────────────
  const searchFiltered = searchQuery.trim()
    ? items.filter(i=>i.name.toLowerCase().includes(searchQuery.toLowerCase()))
    : items;
  const visibleItems = searchFiltered.filter(i => showArchive ? i.archived : !i.archived);
  const archivedCount = items.filter(i=>i.archived).length;
  const rows=[];
  allCats.forEach(cat=>{
    const ci=visibleItems.filter(i=>i.category===cat);
    if (ci.length){rows.push({type:'cat',cat});ci.forEach(item=>rows.push({type:'item',item}));}
  });
  const other=visibleItems.filter(i=>!allCats.includes(i.category));
  if (other.length){rows.push({type:'cat',cat:'Overig'});other.forEach(item=>rows.push({type:'item',item}));}

  // ── Print view ───────────────────────────────────────────────────────────────
  if (printMode) {
    const {bySupplier}=orderList;
    const allIngs = Object.values(bySupplier).flat();
    const checkedCount = allIngs.filter(i=>skipItems.has(i.key)).length;
    const totalCount = allIngs.length;
    const toggleSkip = (key) => setSkipItems(prev => {
      const next = new Set(prev);
      if (next.has(key)) next.delete(key); else next.add(key);
      return next;
    });
    return (
      <div style={{padding:32,fontFamily:'system-ui,sans-serif',background:'#fff',color:'#000',maxWidth:1100,margin:'0 auto'}}>
        <style>{`
          @media print {
            .no-print { display: none !important; }
            .skip-row { display: none !important; }
          }
          .skip-row td.cell-name,
          .skip-row td.cell-amt,
          .skip-row td.cell-src { color: #c00 !important; text-decoration: line-through; text-decoration-color: #c00; text-decoration-thickness: 1.5px; }
          .skip-row { opacity: 0.7; }
        `}</style>
        <div style={{display:'flex',justifyContent:'space-between',alignItems:'flex-start',marginBottom:16}}>
          <div>
            <h1 style={{margin:0,fontSize:24,fontWeight:800}}>Bestelbon — {dept.name}</h1>
            <p style={{margin:'4px 0 0',fontSize:13,color:'#666'}}>{new Date().toLocaleDateString('nl-NL',{weekday:'long',day:'numeric',month:'long'})}</p>
          </div>
          <div className="no-print" style={{display:'flex',gap:8}}>
            <button onClick={()=>{window.print();}} style={{background:'#C07A10',border:'none',color:'#fff',padding:'8px 20px',fontSize:13,fontWeight:600,cursor:'pointer',borderRadius:4}}>🖨 Printen</button>
            <button onClick={()=>setPrintMode(false)} style={{background:'transparent',border:'1px solid #ccc',color:'#333',padding:'8px 16px',fontSize:13,cursor:'pointer',borderRadius:4}}>← Terug</button>
          </div>
        </div>
        {/* Filter bar */}
        <div className="no-print" style={{display:'flex',alignItems:'center',gap:10,marginBottom:18,padding:'10px 14px',background:'#F5F3EF',borderRadius:6,fontSize:13}}>
          <span style={{color:'#555'}}>
            <strong>{checkedCount}</strong> van {totalCount} in huis
            {checkedCount>0 && <span style={{color:'#888'}}> · te bestellen: <strong>{totalCount-checkedCount}</strong></span>}
          </span>
          <div style={{flex:1}}/>
          <button onClick={()=>setHideChecked(h=>!h)} style={{background:hideChecked?'#0D1B38':'#fff',color:hideChecked?'#fff':'#0D1B38',border:'1px solid #0D1B38',padding:'6px 14px',fontSize:12,cursor:'pointer',borderRadius:4,fontWeight:600}}>
            {hideChecked ? '👁 Toon alles' : '🙈 Verberg afgevinkte'}
          </button>
          {checkedCount > 0 && (
            <button onClick={()=>{ if(window.confirm('Alle vinkjes wissen?')) setSkipItems(new Set()); }} style={{background:'transparent',border:'1px solid #ccc',color:'#666',padding:'6px 12px',fontSize:12,cursor:'pointer',borderRadius:4}}>
              Wissen
            </button>
          )}
        </div>
        {Object.entries(bySupplier).map(([sup,ings])=>{
          const visible = hideChecked ? ings.filter(i=>!skipItems.has(i.key)) : ings;
          if (visible.length === 0) return null;
          return (
            <div key={sup} style={{marginBottom:24}}>
              <h2 style={{margin:'0 0 8px',fontSize:15,fontWeight:700,borderBottom:'2px solid #000',paddingBottom:4}}>{sup}</h2>
              <table style={{width:'100%',borderCollapse:'collapse',tableLayout:'fixed'}}>
                <colgroup>
                  <col className="no-print" style={{width:36}}/>
                  <col style={{width:'45%'}}/>
                  <col style={{width:'15%'}}/>
                  <col style={{width:'40%'}}/>
                </colgroup>
                <tbody>
                  {visible.map((ing,i)=>{
                    const checked = skipItems.has(ing.key);
                    return (
                      <tr key={i} className={checked?'skip-row':''} style={{borderBottom:'1px solid #eee'}}>
                        <td className="no-print" style={{padding:'6px 0',verticalAlign:'middle'}}>
                          <input type="checkbox" checked={checked} onChange={()=>toggleSkip(ing.key)} style={{width:16,height:16,cursor:'pointer',accentColor:'#C07A10'}} title={checked?'In huis - klik om te ontvinken':'Afvinken: dit ingrediënt is al in huis'}/>
                        </td>
                        <td className="cell-name" style={{padding:'6px 0',fontSize:14}}>{ing.name}</td>
                        <td className="cell-amt" style={{padding:'6px 0',fontSize:14,fontWeight:700,textAlign:'right',whiteSpace:'nowrap'}}>{ing.total%1===0?ing.total:ing.total.toFixed(1)} {ing.unit}</td>
                        <td className="cell-src" style={{padding:'6px 0 6px 16px',fontSize:11,color:'#888',wordBreak:'break-word'}}>{ing.sources.join(', ')}</td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          );
        })}
      </div>
    );
  }

  // ── Nieuw-recept screen (paste + leeg-optie) ──────────────────────────────────
  if (pasteMode) {
    const preview = pasteText.trim() ? parsePasteRecipe(pasteText) : null;
    const startEmptyRecipe = () => {
      const r = addRecipe();
      setPasteMode(false); setPasteText('');
      setView('recipes');
      setSelRecipeId(r.id);
      setRecipeDraft(JSON.parse(JSON.stringify(r)));
      setRecipeEditing(true);
    };
    return (
      <div style={{display:'flex',flexDirection:'column',height:'100vh',background:'#F0F2F5',fontFamily:'DM Sans,system-ui,sans-serif',fontSize:13,color:C.txt}}>
        <style>{CSS}</style>
        <header style={{height:52,background:C.hdr,borderBottom:`1px solid ${C.hdrBdr}`,display:'flex',alignItems:'center',justifyContent:'space-between',padding:'0 20px',flexShrink:0}}>
          <span style={{fontSize:15,fontWeight:700,color:C.amber}}>Nieuw recept</span>
          <div style={{display:'flex',gap:8}}>
            <button
              onClick={startEmptyRecipe}
              style={{background:'transparent',border:`1px solid ${C.amberBd}`,color:C.amber,padding:'6px 14px',fontSize:12,fontFamily:'inherit',cursor:'pointer',borderRadius:4}}
              title="Begin met een leeg recept en vul handmatig in"
            >
              ☐ Leeg beginnen
            </button>
            <button className="btn-green" style={{background:preview?C.greenBg:'transparent',border:`1px solid ${preview?C.greenBd:C.bdr}`,color:preview?C.green:C.txt3,padding:'6px 16px',fontSize:12,fontFamily:'inherit',fontWeight:600,cursor:preview?'pointer':'not-allowed',borderRadius:4}}
              disabled={!preview}
              onClick={()=>{
                if (!preview) return;
                // Schrijf nu naar Receptenboek (Fase 2): bestaand recept met
                // dezelfde naam wordt bijgewerkt, anders nieuw recept toegevoegd.
                const existing = recipes.find(r => !r.archived && (r.name||'').toLowerCase() === preview.name.toLowerCase());
                if (existing) {
                  // Bij update van bestaand recept: ingrediënten gewijzigd → her-detecteer
                  const newAllergenen = [...new Set([
                    ...(existing.allergenen || []),
                    ...detectAllergenen(preview.ingredients || []),
                  ])];
                  setRecipes(rs => rs.map(r => r.id === existing.id
                    ? {...r, recipe: preview.recipe, ingredients: preview.ingredients, allergenen: newAllergenen}
                    : r
                  ));
                  setPasteMode(false); setPasteText('');
                  setView('recipes');
                  openRecipe(existing.id);
                } else {
                  const r = addRecipe({
                    name: preview.name,
                    category: newForm.category || 'Overig',
                    recipe: preview.recipe,
                    ingredients: preview.ingredients,
                    bewaaradvies: 'Bewaren onder 7°C',
                  });
                  setPasteMode(false); setPasteText('');
                  setView('recipes');
                  openRecipe(r.id);
                }
              }}>
              ✓ {preview ? 'Opslaan in Receptenboek' : 'Plak een recept'}
            </button>
            <button className="btn-ghost" style={{background:'transparent',border:`1px solid ${C.bdr}`,color:C.txt2,padding:'6px 12px',fontSize:12,fontFamily:'inherit',cursor:'pointer',borderRadius:4}}
              onClick={()=>{setPasteMode(false);setPasteText('');}}>Annuleren</button>
          </div>
        </header>
        <div style={{flex:1,overflow:'hidden',display:'flex',gap:0}}>
          {/* Invoer */}
          <div style={{flex:1,padding:16,display:'flex',flexDirection:'column',gap:10,borderRight:`1px solid ${C.bdr}`}}>
            <div style={{fontSize:11,fontWeight:700,color:C.txt2,textTransform:'uppercase',letterSpacing:0.5}}>Plak recept tekst</div>
            <div style={{fontSize:11,color:C.txt3,lineHeight:1.6}}>Eerste regel = naam. Regels met een hoeveelheid worden herkend als ingrediënten. Overige regels = bereiding.</div>
            <textarea style={{flex:1,background:'#fff',border:`1px solid ${C.bdr}`,color:C.txt,fontFamily:'inherit',fontSize:12,padding:10,outline:'none',resize:'none',borderRadius:4,lineHeight:1.7}}
              autoFocus
              placeholder="Hamburgers maken&#10;&#10;500 g rundergehakt&#10;1 ei&#10;50 g paneermeel&#10;zout en peper&#10;&#10;Meng alle ingrediënten.&#10;Vorm balletjes en druk plat.&#10;Bak 4 min per kant." 
              value={pasteText}
              onChange={e=>setPasteText(e.target.value)}
            />
          </div>
          {/* Preview */}
          <div style={{width:300,padding:16,overflowY:'auto',background:C.bg2,flexShrink:0}}>
            <div style={{fontSize:11,fontWeight:700,color:C.txt2,textTransform:'uppercase',letterSpacing:0.5,marginBottom:10}}>Preview</div>
            {!preview ? (
              <div style={{fontSize:12,color:C.txt3,fontStyle:'italic'}}>Plak een recept aan de linkerkant…</div>
            ) : (<>
              <div style={{fontSize:15,fontWeight:700,color:C.txt,marginBottom:2}}>{preview.name}</div>
              <div style={{fontSize:11,color:C.txt3,marginBottom:10}}>{preview.ingredients.length} ingrediënten herkend</div>
              {preview.ingredients.length > 0 && <>
                <div style={{fontSize:10,fontWeight:700,color:C.txt2,textTransform:'uppercase',letterSpacing:0.5,marginBottom:6}}>Ingrediënten</div>
                {preview.ingredients.map(i=>(
                  <div key={i.id} style={{display:'flex',justifyContent:'space-between',padding:'4px 0',borderBottom:`1px solid ${C.bdr}`,fontSize:12}}>
                    <span style={{color:C.txt}}>{i.name}</span>
                    <span style={{color:C.amber,fontWeight:600}}>{i.amount} {i.unit}</span>
                  </div>
                ))}
              </>}
              {preview.recipe && <>
                <div style={{fontSize:10,fontWeight:700,color:C.txt2,textTransform:'uppercase',letterSpacing:0.5,margin:'12px 0 6px'}}>Bereiding</div>
                <div style={{fontSize:12,color:C.txt,lineHeight:1.7,whiteSpace:'pre-wrap'}}>{preview.recipe}</div>
              </>}
            </>)}
          </div>
        </div>
      </div>
    );
  }



  // ── Main app ──────────────────────────────────────────────────────────────────
  return (
    <div style={{display:'flex',flexDirection:'column',height:'100vh',background:'#F0F2F5',fontFamily:'DM Sans,system-ui,sans-serif',fontSize:13,color:C.txt,overflow:'hidden'}}>
      <style>{CSS}</style>

      {/* ── Sidebar overlay ── */}
      <div className={`sidebar-overlay${sidebarOpen?' open':''}`} onClick={()=>setSidebarOpen(false)}/>

      {/* ── Sidebar ── */}
      <div className={`sidebar${sidebarOpen?' open':''}`}>
        <div style={{padding:'20px 20px 16px',borderBottom:'1px solid rgba(255,255,255,.08)',display:'flex',alignItems:'center',justifyContent:'space-between',flexShrink:0}}>
          <span style={{fontSize:15,fontWeight:700,color:'#C99F3B'}}>KitchenControl</span>
          <button onClick={()=>setSidebarOpen(false)} onTouchEnd={e=>{e.preventDefault();setSidebarOpen(false);}}
            style={{width:32,height:32,display:'flex',alignItems:'center',justifyContent:'center',background:'rgba(255,255,255,.06)',border:'1px solid rgba(255,255,255,.1)',borderRadius:6,cursor:'pointer',color:'rgba(255,255,255,.6)',fontSize:16,WebkitTapHighlightColor:'transparent'}}>✕</button>
        </div>
        {/* Sync badge */}
        <div style={{margin:'12px 20px'}}>
          <span className={`sync-badge${syncing?' syncing':''}`} style={{fontSize:11}}>
            <span className="sync-dot"/>
            {syncing?'sync...':'gesync'}
          </span>
        </div>
        {/* Nav items */}
        <div style={{flex:1,overflowY:'auto',paddingBottom:12}}>

          {/* ── NAVIGATIE ── */}
          <div className="sidebar-section-label">Navigatie</div>
          {[
            {id:'mep',      icon:'📋', label:'MEP lijst'},
            {id:'newitem',  icon:'➕', label:'Nieuw item'},
            {id:'newcat',   icon:'📁', label:'Nieuwe categorie'},
            {id:'recipes',  icon:'📖', label:'Receptenboek', badge: recipes.filter(r=>!r.archived).length},
            {id:'paste',    icon:'🍽', label:'Nieuw recept'},
            {id:'order',    icon:'🧾', label:'Bestelbon', badge: dept?.items?.filter(i=>Object.values(i.checks||{}).includes(1)).length||0},
            {id:'archive',  icon:'🗂', label:'Archief'},
          ].map(item=>(
            <div key={item.id} className={`nav-item${view===item.id||( item.id==='archive'&&showArchive)?' active':''}`}
              onClick={()=>{
                if(item.id==='paste'){setPasteMode(true); setShowArchive(false);}
                else if(item.id==='newitem'){setView('mep'); setShowArchive(false); setAddingItem(true);}
                else if(item.id==='newcat'){setView('mep'); setShowArchive(false); setAddingCat(true);}
                else if(item.id==='order'){setPrintMode(true); setShowArchive(false);}
                else if(item.id==='archive'){setShowArchive(a=>!a); setView('mep');}
                else if(item.id==='recipes'){setView('recipes'); setShowArchive(false); closeRecipe();}
                else {setView(item.id); setShowArchive(false);}
                setSidebarOpen(false);
              }}>
              <span className="nav-icon">{item.icon}</span>
              <span className="nav-label">{item.label}</span>
              {item.badge>0&&<span className="nav-badge">{item.badge}</span>}
            </div>
          ))}

          {/* ── TOOLS ── */}
          <div className="sidebar-divider"/>
          <div className="sidebar-section-label">Tools</div>
          <div className="nav-item" onClick={()=>{setShowCalc(true);setShowArchive(false);setSidebarOpen(false);}}>
            <span className="nav-icon">🧮</span><span className="nav-label">Rekenmachine</span>
          </div>
          <div className="nav-item" onClick={()=>{setShowKladblok(true);setShowArchive(false);setSidebarOpen(false);}}>
            <span className="nav-icon">📝</span><span className="nav-label">Kladblok</span>
          </div>

          {/* ── BEHEER ── */}
          <div className="sidebar-divider"/>
          <div className="sidebar-section-label">Beheer</div>
          <div className="nav-item" onClick={()=>{setShowMedewerkersModal(true); setShowArchive(false); setSidebarOpen(false);}}>
            <span className="nav-icon">👥</span>
            <span className="nav-label">Medewerkers</span>
            {medewerkers.length>0&&<span className="nav-badge green">{medewerkers.length}</span>}
          </div>
          <div className="nav-item" onClick={()=>{setShowInfo(true);setShowArchive(false);setSidebarOpen(false);}}>
            <span className="nav-icon">ⓘ</span><span className="nav-label">Over KitchenControl</span>
          </div>

        </div>

        {/* ── Sidebar footer ── */}
        <div className="sidebar-footer">
          <span>{CONFIG.bedrijfsnaam} · Week {getWeekNr(weekOffset)}</span>
          <span>v2.0</span>
        </div>
      </div>

      {/* ── Undo bar ── */}
      {undoItem&&(
        <div className="undo-bar">
          <span>✓ {undoItem.name} afgerond</span>
          <button className="undo-btn" onClick={()=>{
            clearTimeout(undoTimer);
            updItems(its=>its.map(i=>i.id===undoItem.id?{...i,checks:{...i.checks,[undoItem.day]:undoItem.prevState}}:i));
            setUndoItem(null); setUndoTimer(null);
          }}>Ongedaan maken</button>
          <div className="undo-progress"/>
        </div>
      )}

      {/* ── Calculator bottom sheet ── */}
      {showCalc&&(
        <div style={{position:'fixed',inset:0,background:'rgba(13,27,56,.6)',zIndex:9999,display:'flex',alignItems:'flex-end'}} onClick={()=>setShowCalc(false)}>
          <div style={{background:'#fff',borderRadius:'16px 16px 0 0',width:'100%',maxWidth:360,margin:'0 auto',padding:20}} onClick={e=>e.stopPropagation()}>
            <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:12}}>
              <span style={{fontSize:14,fontWeight:700,color:'#0D1B38'}}>Rekenmachine</span>
              <button onClick={()=>setShowCalc(false)} style={{background:'none',border:'none',fontSize:18,cursor:'pointer',color:'#7A8899'}}>×</button>
            </div>
            <div style={{background:'#F5F3EF',borderRadius:8,padding:'12px 16px',fontSize:24,fontWeight:300,textAlign:'right',marginBottom:12,fontFamily:'DM Mono,monospace',color:'#0D1B38',minHeight:52}}>{calcVal}</div>
            <div style={{display:'grid',gridTemplateColumns:'repeat(4,1fr)',gap:8}}>
              {['C','±','%','÷','7','8','9','×','4','5','6','−','1','2','3','+','0','.','⌫','='].map(k=>(
                <button key={k} onClick={()=>{
                  if(k==='C'){setCalcVal('0');setCalcPrev(null);setCalcOp(null);setCalcNew(true);}
                  else if(k==='⌫'){setCalcVal(v=>v.length>1?v.slice(0,-1):'0');}
                  else if(k==='±'){setCalcVal(v=>String(-parseFloat(v)));}
                  else if(k==='%'){setCalcVal(v=>String(parseFloat(v)/100));}
                  else if(['÷','×','−','+'].includes(k)){
                    setCalcPrev(parseFloat(calcVal));
                    setCalcOp(k); setCalcNew(true);
                  }
                  else if(k==='='){
                    if(calcOp&&calcPrev!==null){
                      const a=calcPrev, b=parseFloat(calcVal);
                      const res = calcOp==='+'?a+b:calcOp==='−'?a-b:calcOp==='×'?a*b:calcOp==='÷'?a/b:b;
                      setCalcVal(String(parseFloat(res.toFixed(8))));
                      setCalcPrev(null); setCalcOp(null); setCalcNew(true);
                    }
                  }
                  else {
                    setCalcVal(v=>calcNew||v==='0'?k:v+k);
                    setCalcNew(false);
                  }
                }}
                style={{padding:'14px 0',fontSize:16,fontWeight:['÷','×','−','+','='].includes(k)?700:400,
                  background:k==='='?'#C99F3B':k==='C'?'#E4DFD7':'#F5F3EF',
                  color:k==='='?'#0D1B38':'#0D1B38',
                  border:'none',borderRadius:8,cursor:'pointer',fontFamily:'inherit',
                  WebkitTapHighlightColor:'transparent'}}>
                  {k}
                </button>
              ))}
            </div>
          </div>
        </div>
      )}

      {/* ── Kladblok bottom sheet ── */}
      {showKladblok&&(()=>{
        const today = new Date().toISOString().split('T')[0];
        const key = `${activeDept}_${today}`;
        const deptName = dept?.name||'';
        return (
          <div style={{position:'fixed',inset:0,background:'rgba(13,27,56,.6)',zIndex:9999,display:'flex',alignItems:'flex-end'}} onClick={()=>setShowKladblok(false)}>
            <div style={{background:'#fff',borderRadius:'16px 16px 0 0',width:'100%',padding:20,display:'flex',flexDirection:'column',gap:12,maxHeight:'60vh'}} onClick={e=>e.stopPropagation()}>
              <div style={{display:'flex',justifyContent:'space-between',alignItems:'center'}}>
                <div>
                  <div style={{fontSize:14,fontWeight:700,color:'#0D1B38'}}>📝 Kladblok</div>
                  <div style={{fontSize:11,color:'#7A8899'}}>{deptName} · {today}</div>
                </div>
                <button onClick={()=>setShowKladblok(false)} style={{background:'none',border:'none',fontSize:18,cursor:'pointer',color:'#7A8899'}}>×</button>
              </div>
              <textarea
                style={{flex:1,minHeight:150,background:'#F5F3EF',border:'1px solid #E4DFD7',borderRadius:8,padding:12,fontFamily:'inherit',fontSize:13,color:'#0D1B38',outline:'none',resize:'none',lineHeight:1.6}}
                placeholder="Aandachtspunten voor vandaag..."
                maxLength={500}
                value={kladblok[key]||''}
                onChange={e=>setKladblok(k=>({...k,[key]:e.target.value}))}
              />
              <div style={{fontSize:11,color:'#7A8899',textAlign:'right'}}>{(kladblok[key]||'').length}/500</div>
            </div>
          </div>
        );
      })()}

      {/* Info modal */}
      {showInfo&&(
        <div style={{position:'fixed',inset:0,background:'rgba(12,24,53,0.75)',zIndex:100,display:'flex',alignItems:'center',justifyContent:'center',padding:20}}
          onClick={()=>setShowInfo(false)}>
          <div style={{background:'#fff',borderRadius:10,padding:28,maxWidth:320,width:'100%',display:'flex',flexDirection:'column',gap:14,boxShadow:'0 8px 32px rgba(0,0,0,0.2)'}}
            onClick={e=>e.stopPropagation()}>
            {/* Logo area */}
            <div style={{display:'flex',flexDirection:'column',alignItems:'center',gap:6,paddingBottom:14,borderBottom:'1px solid #BCCEFB'}}>
              <div style={{fontSize:22,fontWeight:800,color:'#0C1835',letterSpacing:1}}>Kitchen<span style={{color:'#C9A84C'}}>Control</span></div>
              <div style={{fontSize:11,color:'#8FA3CC'}}>Digitale keukenoplossingen voor de horeca</div>
            </div>
            {/* App info */}
            <div style={{display:'flex',flexDirection:'column',gap:8}}>
              <div style={{display:'flex',justifyContent:'space-between',fontSize:12}}>
                <span style={{color:'#8FA3CC'}}>Applicatie</span>
                <span style={{fontWeight:600,color:'#0C1835'}}>MEP — Mise en Place</span>
              </div>
              <div style={{display:'flex',justifyContent:'space-between',fontSize:12}}>
                <span style={{color:'#8FA3CC'}}>Klant</span>
                <span style={{fontWeight:600,color:'#0C1835'}}>{CONFIG.bedrijfsnaam}</span>
              </div>
              <div style={{display:'flex',justifyContent:'space-between',fontSize:12}}>
                <span style={{color:'#8FA3CC'}}>Versie</span>
                <span style={{fontWeight:600,color:'#0C1835'}}>2.0</span>
              </div>
              <div style={{display:'flex',justifyContent:'space-between',fontSize:12}}>
                <span style={{color:'#8FA3CC'}}>Website</span>
                <a href="https://kitchencontrol.nl" target="_blank" rel="noopener noreferrer"
                  style={{color:'#C9A84C',fontWeight:600,textDecoration:'none'}}>kitchencontrol.nl</a>
              </div>
            </div>
            {/* Footer */}
            <div style={{paddingTop:10,borderTop:'1px solid #BCCEFB',textAlign:'center'}}>
              <div style={{fontSize:11,color:'#8FA3CC',marginBottom:12}}>© 2026 KitchenControl · Alle rechten voorbehouden</div>
              <button style={{background:'#0C1835',border:'none',color:'#C9A84C',padding:'8px 24px',fontFamily:'inherit',fontSize:12,fontWeight:700,cursor:'pointer',borderRadius:6,width:'100%'}}
                onClick={()=>setShowInfo(false)}>Sluiten</button>
            </div>
          </div>
        </div>
      )}

      {/* ══ Categorie-manager modal ══════════════════════════════════════════ */}
      {showCatManager && (
        <div style={{position:'fixed',inset:0,background:'rgba(12,24,53,0.75)',zIndex:100,display:'flex',alignItems:'center',justifyContent:'center',padding:20}}
          onClick={()=>{setShowCatManager(false); setNewCatInManager('');}}>
          <div style={{background:'#fff',borderRadius:10,padding:0,maxWidth:420,width:'100%',maxHeight:'80vh',display:'flex',flexDirection:'column',boxShadow:'0 8px 32px rgba(0,0,0,0.2)'}}
            onClick={e=>e.stopPropagation()}>
            <div style={{padding:'16px 18px 12px',borderBottom:`1px solid ${C.bdr}`,display:'flex',alignItems:'center',justifyContent:'space-between'}}>
              <div>
                <div style={{fontSize:15,fontWeight:700,color:C.txt}}>🗂 Categorieën beheren</div>
                <div style={{fontSize:11,color:C.txt3,marginTop:2}}>Voor recepten en MEP-items</div>
              </div>
              <button onClick={()=>{setShowCatManager(false); setNewCatInManager('');}}
                style={{background:'transparent',border:'none',fontSize:18,color:C.txt3,cursor:'pointer',padding:'4px 8px',fontFamily:'inherit'}}>✕</button>
            </div>

            <div style={{flex:1,overflowY:'auto',padding:'12px 18px'}}>
              {/* Toevoegen */}
              <div style={{marginBottom:18}}>
                <div style={{fontSize:10,letterSpacing:1,color:C.txt2,marginBottom:6,fontWeight:600,textTransform:'uppercase'}}>Nieuwe categorie</div>
                <div style={{display:'flex',gap:6}}>
                  <input autoFocus
                    style={{flex:1,background:'#fff',border:`1px solid ${C.bdr}`,color:C.txt,padding:'7px 10px',fontFamily:'inherit',fontSize:12,outline:'none',borderRadius:4}}
                    placeholder="Bijv. Desserts"
                    value={newCatInManager}
                    onChange={e=>setNewCatInManager(e.target.value)}
                    onKeyDown={e=>{
                      if (e.key === 'Enter' && addCustomCat(newCatInManager)) setNewCatInManager('');
                    }}
                  />
                  <button
                    onClick={()=>{ if (addCustomCat(newCatInManager)) setNewCatInManager(''); }}
                    disabled={!newCatInManager.trim() || allCats.includes(newCatInManager.trim())}
                    style={{background:newCatInManager.trim() && !allCats.includes(newCatInManager.trim())?C.amber:'transparent',border:newCatInManager.trim() && !allCats.includes(newCatInManager.trim())?'none':`1px solid ${C.bdr}`,color:newCatInManager.trim() && !allCats.includes(newCatInManager.trim())?'#0D1B38':C.txt3,padding:'7px 14px',fontFamily:'inherit',fontSize:12,fontWeight:600,cursor:newCatInManager.trim() && !allCats.includes(newCatInManager.trim())?'pointer':'not-allowed',borderRadius:4}}
                  >+ Toevoegen</button>
                </div>
                {newCatInManager.trim() && allCats.includes(newCatInManager.trim()) && (
                  <div style={{fontSize:11,color:C.red,marginTop:6}}>Deze categorie bestaat al.</div>
                )}
              </div>

              {/* Standaard categorieën */}
              <div style={{marginBottom:18}}>
                <div style={{fontSize:10,letterSpacing:1,color:C.txt2,marginBottom:8,fontWeight:600,textTransform:'uppercase'}}>Standaard (vast)</div>
                <div style={{display:'flex',flexDirection:'column',gap:4}}>
                  {CAT_ORDER.map(cat => {
                    const cnt = recipes.filter(r => r.category === cat && !r.archived).length;
                    return (
                      <div key={cat} style={{display:'flex',alignItems:'center',justifyContent:'space-between',padding:'8px 12px',background:'#FAFAF8',border:`1px solid ${C.bdr}`,borderRadius:4}}>
                        <span style={{fontSize:13,color:C.txt}}>{cat}</span>
                        <span style={{fontSize:11,color:C.txt3}}>
                          {cnt > 0 ? `${cnt} recept${cnt===1?'':'en'}` : 'leeg'}
                        </span>
                      </div>
                    );
                  })}
                </div>
              </div>

              {/* Custom categorieën */}
              <div>
                <div style={{fontSize:10,letterSpacing:1,color:C.txt2,marginBottom:8,fontWeight:600,textTransform:'uppercase'}}>Eigen categorieën</div>
                {customCats.length === 0 ? (
                  <div style={{fontSize:12,color:C.txt3,fontStyle:'italic',padding:'8px 0'}}>Nog geen eigen categorieën toegevoegd.</div>
                ) : (
                  <div style={{display:'flex',flexDirection:'column',gap:4}}>
                    {customCats.map(cat => {
                      const cnt = recipes.filter(r => r.category === cat && !r.archived).length;
                      return (
                        <div key={cat} style={{display:'flex',alignItems:'center',justifyContent:'space-between',padding:'8px 12px',background:'#fff',border:`1px solid ${C.bdr}`,borderRadius:4}}>
                          <span style={{fontSize:13,color:C.txt}}>{cat}</span>
                          <div style={{display:'flex',alignItems:'center',gap:8}}>
                            <span style={{fontSize:11,color:C.txt3}}>
                              {cnt > 0 ? `${cnt} recept${cnt===1?'':'en'}` : 'leeg'}
                            </span>
                            <button
                              onClick={()=>deleteCustomCat(cat)}
                              style={{background:'transparent',border:`1px solid ${C.redBd}`,color:C.red,padding:'3px 8px',fontFamily:'inherit',fontSize:11,cursor:'pointer',borderRadius:3}}
                              title="Categorie verwijderen"
                            >✕</button>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                )}
              </div>
            </div>

            <div style={{padding:'12px 18px',borderTop:`1px solid ${C.bdr}`}}>
              <button onClick={()=>{setShowCatManager(false); setNewCatInManager('');}}
                style={{background:'#0C1835',border:'none',color:'#C9A84C',padding:'8px 24px',fontFamily:'inherit',fontSize:12,fontWeight:700,cursor:'pointer',borderRadius:6,width:'100%'}}
              >Sluiten</button>
            </div>
          </div>
        </div>
      )}

      {/* ══ Medewerkers modal ════════════════════════════════════════════════ */}
      {showMedewerkersModal && (
        <div style={{position:'fixed',inset:0,background:'rgba(12,24,53,0.65)',zIndex:100,display:'flex',alignItems:'center',justifyContent:'center',padding:10}}
          onClick={()=>{setShowMedewerkersModal(false); setAddingMed(false); setNewMedNaam('');}}>
          <div style={{background:'#fff',borderRadius:10,padding:0,maxWidth:460,width:'100%',maxHeight:'85vh',display:'flex',flexDirection:'column',boxShadow:'0 8px 32px rgba(0,0,0,0.2)'}}
            onClick={e=>e.stopPropagation()}>

            {/* Header */}
            <div style={{padding:'16px 18px 12px',borderBottom:`1px solid ${C.bdr}`,display:'flex',alignItems:'center',justifyContent:'space-between'}}>
              <div>
                <div style={{fontSize:15,fontWeight:700,color:C.txt}}>Medewerkers</div>
                <div style={{fontSize:11,color:C.txt3,marginTop:2}}>Klik op een naam voor uren-overzicht</div>
              </div>
              <button onClick={()=>{setShowMedewerkersModal(false); setAddingMed(false); setNewMedNaam('');}}
                style={{background:'transparent',border:'none',fontSize:18,color:C.txt3,cursor:'pointer',padding:'4px 8px',fontFamily:'inherit'}}>✕</button>
            </div>

            {/* Lijst */}
            <div style={{flex:1,overflowY:'auto',padding:'10px 18px'}}>
              {medewerkers.length === 0 ? (
                <div style={{padding:'30px 0',textAlign:'center',color:C.txt3,fontSize:13}}>
                  Nog geen medewerkers toegevoegd.
                </div>
              ) : (
                <div style={{display:'flex',flexDirection:'column',gap:6}}>
                  {medewerkers.map(m => {
                    const wkUren = weekTotaalUren(m, weekOffset);
                    return (
                      <div key={m.id}
                        onClick={()=>{setUrenMedewerker(m.id); setUrenWeekOffset(weekOffset);}}
                        style={{
                          display:'flex',alignItems:'center',gap:10,
                          padding:'10px 12px',
                          background:'#fff',
                          border:`1px solid ${C.bdr}`,
                          borderRadius:8,
                          cursor:'pointer',
                          transition:'background .12s',
                        }}
                        onMouseEnter={e=>e.currentTarget.style.background='#FAFAF8'}
                        onMouseLeave={e=>e.currentTarget.style.background='#fff'}
                      >
                        <div style={{width:32,height:32,borderRadius:'50%',background:'#C99F3B',display:'flex',alignItems:'center',justifyContent:'center',fontSize:13,fontWeight:700,color:'#0D1B38',flexShrink:0}}>
                          {m.naam[0].toUpperCase()}
                        </div>
                        <div style={{flex:1,minWidth:0}}>
                          <div style={{fontSize:14,fontWeight:600,color:C.txt}}>{m.naam}</div>
                          {wkUren > 0 && (
                            <div style={{fontSize:11,color:C.txt3,marginTop:2}}>
                              Deze week: <span style={{color:C.amber,fontWeight:600}}>{wkUren.toFixed(2).replace('.',',')}u</span>
                            </div>
                          )}
                        </div>
                        <button
                          onClick={e=>{
                            e.stopPropagation();
                            if(window.confirm(`Medewerker "${m.naam}" verwijderen?\n\nAlle uren-historie gaat ook verloren.`))
                              setMedewerkers(ms=>ms.filter(x=>x.id!==m.id));
                          }}
                          style={{background:'transparent',border:`1px solid ${C.redBd}`,color:C.red,padding:'4px 9px',fontFamily:'inherit',fontSize:11,cursor:'pointer',borderRadius:4}}
                          title="Medewerker verwijderen"
                        >✕</button>
                        <span style={{color:C.txt3,fontSize:14}}>›</span>
                      </div>
                    );
                  })}
                </div>
              )}

              {/* Toevoegen-flow */}
              <div style={{marginTop:14,paddingTop:14,borderTop:`1px solid ${C.bdr}`}}>
                {addingMed ? (
                  <div style={{display:'flex',gap:6}}>
                    <input autoFocus
                      style={{flex:1,background:'#fff',border:`1px solid ${C.bdr}`,color:C.txt,padding:'8px 12px',fontFamily:'inherit',fontSize:13,outline:'none',borderRadius:6}}
                      placeholder="Naam medewerker"
                      value={newMedNaam}
                      onChange={e=>setNewMedNaam(e.target.value)}
                      onKeyDown={e=>{
                        if(e.key==='Enter' && newMedNaam.trim()){
                          setMedewerkers(ms=>[...ms,{id:uid(),naam:newMedNaam.trim()}]);
                          setNewMedNaam(''); setAddingMed(false);
                        } else if (e.key === 'Escape') {
                          setNewMedNaam(''); setAddingMed(false);
                        }
                      }}/>
                    <button
                      onClick={()=>{
                        if(newMedNaam.trim()){
                          setMedewerkers(ms=>[...ms,{id:uid(),naam:newMedNaam.trim()}]);
                          setNewMedNaam(''); setAddingMed(false);
                        }
                      }}
                      style={{background:C.amber,border:'none',color:'#0D1B38',padding:'8px 14px',fontFamily:'inherit',fontSize:13,fontWeight:700,cursor:'pointer',borderRadius:6}}
                    >+ Toevoegen</button>
                    <button
                      onClick={()=>{setNewMedNaam(''); setAddingMed(false);}}
                      style={{background:'transparent',border:`1px solid ${C.bdr}`,color:C.txt2,padding:'8px 12px',fontFamily:'inherit',fontSize:13,cursor:'pointer',borderRadius:6}}
                    >Annuleren</button>
                  </div>
                ) : (
                  <button
                    onClick={()=>setAddingMed(true)}
                    style={{background:'transparent',border:`1px dashed ${C.bdr2}`,color:C.txt2,padding:'9px 16px',fontFamily:'inherit',fontSize:12,cursor:'pointer',borderRadius:6,width:'100%'}}
                  >+ Medewerker toevoegen</button>
                )}
              </div>
            </div>

            {/* Footer */}
            <div style={{padding:'12px 18px',borderTop:`1px solid ${C.bdr}`}}>
              <button onClick={()=>{setShowMedewerkersModal(false); setAddingMed(false); setNewMedNaam('');}}
                style={{background:'#0C1835',border:'none',color:'#C9A84C',padding:'8px 22px',fontFamily:'inherit',fontSize:12,fontWeight:700,cursor:'pointer',borderRadius:6,width:'100%'}}
              >Sluiten</button>
            </div>
          </div>
        </div>
      )}

      {/* ══ Uren-registratie modal ════════════════════════════════════════════ */}
      {urenMedewerker && (() => {
        const m = medewerkers.find(x => x.id === urenMedewerker);
        if (!m) return null;
        const keys = weekDayKeysFor(urenWeekOffset);
        const wkInfo = isoWeekOf(targetDate(0, urenWeekOffset));
        const totaal = weekTotaalUren(m, urenWeekOffset);
        // Historie: lijst van alle weken waarvoor entries bestaan
        const allKeys = [...new Set((m.uren||[]).map(u => u.dayKey))];
        const weekSet = new Set();
        allKeys.forEach(k => {
          const match = /^(\d{4})-W(\d{2})-/.exec(k);
          if (match) weekSet.add(`${match[1]}-W${match[2]}`);
        });

        return (
          <div style={{position:'fixed',inset:0,background:'rgba(12,24,53,0.75)',zIndex:100,display:'flex',alignItems:'center',justifyContent:'center',padding:10}}
            onClick={()=>setUrenMedewerker(null)}>
            <div style={{background:'#fff',borderRadius:10,padding:0,maxWidth:580,width:'100%',maxHeight:'92vh',display:'flex',flexDirection:'column',boxShadow:'0 8px 32px rgba(0,0,0,0.2)'}}
              onClick={e=>e.stopPropagation()}>

              {/* Header */}
              <div style={{padding:'16px 18px 12px',borderBottom:`1px solid ${C.bdr}`,display:'flex',alignItems:'center',justifyContent:'space-between',gap:10}}>
                <div style={{display:'flex',alignItems:'center',gap:10}}>
                  <div style={{width:36,height:36,borderRadius:'50%',background:'#C99F3B',display:'flex',alignItems:'center',justifyContent:'center',fontSize:15,fontWeight:700,color:'#0D1B38',flexShrink:0}}>{m.naam[0].toUpperCase()}</div>
                  <div>
                    <div style={{fontSize:15,fontWeight:700,color:C.txt}}>{m.naam}</div>
                    <div style={{fontSize:11,color:C.txt3,marginTop:2}}>Uren-registratie</div>
                  </div>
                </div>
                <button onClick={()=>setUrenMedewerker(null)}
                  style={{background:'transparent',border:'none',fontSize:18,color:C.txt3,cursor:'pointer',padding:'4px 8px',fontFamily:'inherit'}}>✕</button>
              </div>

              {/* Week navigatie */}
              <div style={{padding:'12px 18px 0',display:'flex',alignItems:'center',justifyContent:'space-between',gap:8}}>
                <button onClick={()=>setUrenWeekOffset(o=>o-1)}
                  style={{background:'transparent',border:`1px solid ${C.bdr}`,color:C.txt2,padding:'6px 14px',fontFamily:'inherit',fontSize:12,cursor:'pointer',borderRadius:6}}
                >‹ vorige</button>
                <div style={{textAlign:'center'}}>
                  <div style={{fontSize:13,fontWeight:600,color:C.txt}}>Week {wkInfo.week} · {wkInfo.year}</div>
                  <div style={{fontSize:11,color:C.txt3}}>Totaal: <strong style={{color:C.amber,fontSize:13}}>{totaal.toFixed(2).replace('.',',')}u</strong></div>
                </div>
                <button onClick={()=>setUrenWeekOffset(o=>o+1)}
                  style={{background:'transparent',border:`1px solid ${C.bdr}`,color:C.txt2,padding:'6px 14px',fontFamily:'inherit',fontSize:12,cursor:'pointer',borderRadius:6}}
                >volgende ›</button>
              </div>

              {/* Dag-tabel */}
              <div style={{flex:1,overflowY:'auto',padding:'12px 18px'}}>
                <div style={{display:'flex',flexDirection:'column',gap:6}}>
                  {DAYS.map((d, i) => {
                    const dk = keys[i];
                    const entry = (m.uren||[]).find(u => u.dayKey === dk) || {start:'',eind:'',pauze:30};
                    const dagUren = berekenDagUren(entry.start, entry.eind, entry.pauze||0);
                    return (
                      <div key={dk} style={{display:'grid',gridTemplateColumns:'40px 1fr 1fr 70px 60px',gap:6,alignItems:'center',padding:'6px 4px',borderBottom:`1px solid ${C.bdr}`,fontSize:12}}>
                        <div style={{fontWeight:600,color:C.txt}}>{d}</div>
                        <input type="time" value={entry.start||''}
                          onChange={e=>updateUrenEntry(m.id, dk, {start:e.target.value})}
                          style={{background:'#FAFAF8',border:`1px solid ${C.bdr}`,color:C.txt,padding:'5px 6px',fontFamily:'inherit',fontSize:12,outline:'none',borderRadius:4,width:'100%'}}
                          placeholder="Start"
                        />
                        <input type="time" value={entry.eind||''}
                          onChange={e=>updateUrenEntry(m.id, dk, {eind:e.target.value})}
                          style={{background:'#FAFAF8',border:`1px solid ${C.bdr}`,color:C.txt,padding:'5px 6px',fontFamily:'inherit',fontSize:12,outline:'none',borderRadius:4,width:'100%'}}
                          placeholder="Eind"
                        />
                        <select value={entry.pauze??30}
                          onChange={e=>updateUrenEntry(m.id, dk, {pauze:parseInt(e.target.value,10)})}
                          style={{background:'#FAFAF8',border:`1px solid ${C.bdr}`,color:C.txt2,padding:'5px 4px',fontFamily:'inherit',fontSize:11,outline:'none',borderRadius:4,cursor:'pointer'}}
                        >
                          {[0,15,30,45,60].map(p => <option key={p} value={p}>{p===0?'geen':`${p}m`}</option>)}
                        </select>
                        <div style={{textAlign:'right',fontFamily:"'DM Mono', monospace",fontWeight:600,color:dagUren>0?C.txt:C.txt3,fontSize:12}}>
                          {dagUren>0?`${dagUren.toFixed(2).replace('.',',')}u`:'—'}
                        </div>
                      </div>
                    );
                  })}
                </div>

                {/* Geschiedenis-knop */}
                {weekSet.size > 1 && (
                  <div style={{marginTop:18,paddingTop:12,borderTop:`1px solid ${C.bdr}`}}>
                    <div style={{fontSize:10,letterSpacing:1,color:C.txt2,marginBottom:8,fontWeight:600,textTransform:'uppercase'}}>Geschiedenis ({weekSet.size} weken)</div>
                    <div style={{fontSize:11,color:C.txt3}}>
                      Navigeer met ‹ vorige / volgende › om eerdere weken te bekijken.
                    </div>
                  </div>
                )}
              </div>

              {/* Footer */}
              <div style={{padding:'12px 18px',borderTop:`1px solid ${C.bdr}`,display:'flex',gap:8,justifyContent:'space-between',alignItems:'center'}}>
                <button onClick={()=>downloadWeekrapport(urenWeekOffset)}
                  style={{background:'transparent',border:`1px solid ${C.amberBd}`,color:C.amber,padding:'8px 14px',fontFamily:'inherit',fontSize:12,fontWeight:600,cursor:'pointer',borderRadius:6}}
                  title="Download weekrapport voor alle medewerkers"
                >📊 Download weekrapport (CSV)</button>
                <button onClick={()=>setUrenMedewerker(null)}
                  style={{background:'#0C1835',border:'none',color:'#C9A84C',padding:'8px 22px',fontFamily:'inherit',fontSize:12,fontWeight:700,cursor:'pointer',borderRadius:6}}
                >Sluiten</button>
              </div>
            </div>
          </div>
        );
      })()}

      {/* Header */}
      <header style={{background:'#0D1B38',boxShadow:'0 2px 12px rgba(13,27,56,.30)',flexShrink:0}}>
        <div style={{height:52,display:'flex',alignItems:'center',padding:'0 12px',gap:10}}>
          <button
            onClick={()=>setSidebarOpen(true)}
            onTouchEnd={e=>{e.preventDefault();e.stopPropagation();setSidebarOpen(true);}}
            style={{width:36,height:36,display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',gap:5,cursor:'pointer',borderRadius:8,background:'rgba(255,255,255,.06)',border:'1px solid rgba(255,255,255,.1)',flexShrink:0,WebkitTapHighlightColor:'transparent'}}>
            <span style={{display:'block',width:16,height:2,background:'rgba(255,255,255,.8)',borderRadius:1}}/>
            <span style={{display:'block',width:16,height:2,background:'rgba(255,255,255,.8)',borderRadius:1}}/>
            <span style={{display:'block',width:16,height:2,background:'rgba(255,255,255,.8)',borderRadius:1}}/>
          </button>
          <div style={{display:'flex',alignItems:'center',gap:8}}>
            {CONFIG.logoUrl
              ? <img src={CONFIG.logoUrl} alt={CONFIG.bedrijfsnaam} style={{height:28,width:'auto',objectFit:'contain'}}/>
              : <span style={{fontSize:17,fontWeight:700,color:'#C99F3B',letterSpacing:0.5}}>{CONFIG.bedrijfsnaam}</span>
            }
            <span style={{fontSize:10,fontWeight:600,color:'rgba(255,255,255,0.35)',letterSpacing:2,textTransform:'uppercase',padding:'2px 6px',border:'1px solid rgba(255,255,255,0.1)',borderRadius:3}}>MEP</span>
          </div>
          <div style={{flex:1}}/>
        </div>
        {/* Department tabs */}
        <div style={{display:'flex',alignItems:'center',gap:0,paddingLeft:16,overflowX:'auto',borderTop:'1px solid rgba(255,255,255,0.07)',WebkitOverflowScrolling:'touch'}}>
          {depts.map(d=>(
            <div key={d.id} style={{display:'flex',alignItems:'center'}}>
              <button className="dept-tab" style={{padding:'9px 16px 10px',fontSize:12.8,fontFamily:'inherit',border:'none',borderBottom:d.id===activeDept?'2px solid #C9A84C':'2px solid transparent',color:d.id===activeDept?'#C9A84C':'rgba(255,255,255,.45)',background:'transparent',cursor:'pointer',fontWeight:d.id===activeDept?600:500,whiteSpace:'nowrap',transition:'all 0.12s',display:'flex',alignItems:'center',gap:6}} onClick={()=>setActiveDept(d.id)}
                onTouchEnd={e=>{e.preventDefault();e.stopPropagation();setActiveDept(d.id);}}>
                {d.name}
                {(() => {
                  const n=d.items.filter(i=>!i.archived&&Object.values(i.checks||{}).some(v=>v===1)).length;
                  if (n===0) return null;
                  // Active tab: tonen we niets (✕-knop staat rechts hiernaast)
                  // Inactive tab: gouden dot als indicator dat hier geplande items zijn
                  if (d.id===activeDept) return null;
                  return <span style={{width:6,height:6,borderRadius:'50%',background:'#C9A84C',display:'inline-block',flexShrink:0}}/>;
                })()}
              </button>
              {depts.length>1&&d.id===activeDept&&<button onClick={()=>delDept(d.id)} style={{background:'none',border:'none',color:'rgba(255,255,255,0.35)',cursor:'pointer',fontSize:12,padding:'0 4px',lineHeight:1,WebkitTapHighlightColor:'transparent'}} title="Afdeling verwijderen">✕</button>}
            </div>
          ))}
          {addingDept?(
            <div style={{display:'flex',alignItems:'center',gap:5,padding:'4px 8px'}}>
              <input autoFocus style={{background:'#fff',border:`1px solid ${C.amberBd}`,color:C.txt,padding:'3px 8px',fontFamily:'inherit',fontSize:12,outline:'none',borderRadius:4,width:130}} placeholder="Naam afdeling" value={newDeptName} onChange={e=>setNewDeptName(e.target.value)} onKeyDown={e=>e.key==='Enter'&&addDept()}/>
              <button onClick={addDept} style={{background:C.amber,border:'none',color:'#fff',padding:'3px 10px',fontSize:11,fontFamily:'inherit',cursor:'pointer',borderRadius:4}}>+</button>
              <button onClick={()=>{setAddingDept(false);setNewDeptName('');}} style={{background:'none',border:`1px solid ${C.bdr}`,color:C.txt2,padding:'3px 7px',fontSize:11,fontFamily:'inherit',cursor:'pointer',borderRadius:4}}>✕</button>
            </div>
          ):(
            <button className="btn-add-dept" style={{padding:'7px 12px',fontSize:12,fontFamily:'inherit',border:'none',background:'transparent',color:'#8FA3CC',cursor:'pointer',whiteSpace:'nowrap'}} onClick={()=>setAddingDept(true)}>+ Afdeling</button>
          )}
        </div>
      </header>

      {/* Body */}
      <div style={{display:'flex',flex:1,overflow:'hidden'}}>

        {/* Main pane */}
        <div style={{flex:1,minWidth:0,display:'flex',flexDirection:'column',overflow:'hidden'}} className={selId?'main-hide':''}>
          {view==='mep'?(<>
            {/* ── Week navigation + Day selector ── */}
            <div style={{background:'#fff',borderBottom:'1px solid #E4DFD7',flexShrink:0}}>
              {/* Week nav */}
              <div style={{display:'flex',alignItems:'center',justifyContent:'space-between',padding:'8px 16px 4px'}}>
                <button
                  onClick={()=>setWeekOffset(w=>w-1)}
                  onTouchEnd={e=>{e.preventDefault();setWeekOffset(w=>w-1);}}
                  style={{background:'none',border:'1px solid #E4DFD7',color:'#7A8899',borderRadius:6,padding:'4px 10px',cursor:'pointer',fontSize:13,fontFamily:'inherit',WebkitTapHighlightColor:'transparent'}}>←</button>
                <div style={{textAlign:'center'}}>
                  <div style={{fontSize:11,fontWeight:700,color:'#0D1B38',letterSpacing:0.5}}>Week {getWeekNr(weekOffset)}</div>
                  <div style={{fontSize:10,color:'#7A8899'}}>{getWeekLabel(weekOffset)}</div>
                </div>
                <button
                  onClick={()=>setWeekOffset(w=>w+1)}
                  onTouchEnd={e=>{e.preventDefault();setWeekOffset(w=>w+1);}}
                  style={{background:'none',border:'1px solid #E4DFD7',color:'#7A8899',borderRadius:6,padding:'4px 10px',cursor:'pointer',fontSize:13,fontFamily:'inherit',WebkitTapHighlightColor:'transparent'}}>→</button>
              </div>
              {/* Day buttons */}
              <div className="day-selector" style={{paddingTop:6}}>
                {DAYS.map((d,di)=>{
                  const dk = dayKey(d, weekOffset);
                  const isActive = selectedDay===dk;
                  const isToday  = di===todayIdx && weekOffset===0;
                  const items2 = dept?.items?.filter(i=>!i.archived)||[];
                  const planned2 = items2.filter(i=>(i.checks?.[dk]||0)===1).length;
                  const done2    = items2.filter(i=>(i.checks?.[dk]||0)===2).length;
                  const allDone2 = done2>0 && done2===items2.filter(i=>(i.checks?.[dk]||0)>0).length;
                  return (
                    <button key={d} className={`day-btn${isActive?' active':''}${isToday?' today':''}`}
                      onClick={()=>setSelectedDay(dk)}
                      onTouchEnd={e=>{e.preventDefault();e.stopPropagation();setSelectedDay(dk);}}>
                      <span className="day-letter">{d}</span>
                      <span className="day-num">{getDayDate(di, weekOffset)}</span>
                      {(planned2>0||done2>0)&&(
                        <span style={{width:done2>0&&planned2===0?8:6,height:done2>0&&planned2===0?8:6,borderRadius:'50%',background:done2>0&&planned2===0?'#2A9D5C':'#C99F3B',marginTop:3,display:'block',flexShrink:0}}/>
                      )}
                    </button>
                  );
                })}
              </div>
            </div>
            {/* ── Progress bar ── */}
            {(()=>{
              const allItems = dept?.items?.filter(i=>!i.archived)||[];
              const total    = allItems.length;
              const planned  = allItems.filter(i=>(i.checks?.[selectedDay]||0)===1).length;
              const done     = allItems.filter(i=>(i.checks?.[selectedDay]||0)===2).length;
              const todo     = planned; // gepland maar nog niet gedaan
              const pct      = total>0 ? Math.round((todo/total)*100) : 0;
              const allDone  = total>0 && todo===0 && done>0;
              const color    = allDone
                ? 'linear-gradient(90deg, #2A9D5C, #2A9D5C)'
                : pct > 60
                  ? 'linear-gradient(90deg, #C0392B, #E0B94A)'
                  : 'linear-gradient(90deg, #1A2E5A, #C99F3B)';
              return (
                <div className="progress-bar">
                  <div className="progress-track">
                    <div className="progress-fill" style={{width:`${pct}%`, background:color}}/>
                  </div>
                  <span className="progress-label" style={{color: allDone?'#2A9D5C': todo>0?'#C0392B':'#7A8899'}}>
                    {allDone ? '✓ klaar' : `${todo} te doen`}
                  </span>
                  <button onClick={()=>{setSearchOpen(s=>!s);if(searchOpen)setSearchQuery('');}}
                    onTouchEnd={e=>{e.preventDefault();setSearchOpen(s=>!s);if(searchOpen)setSearchQuery('');}}
                    style={{background:'none',border:'none',color:searchOpen?'#C99F3B':'#7A8899',cursor:'pointer',fontSize:15,padding:'0 4px',WebkitTapHighlightColor:'transparent',flexShrink:0}}>🔍</button>
                </div>
              );
            })()}
            {/* ── Search bar ── */}
            <div className="search-bar" style={{display:searchOpen?'flex':'none'}}>
              <input className="search-input" autoFocus placeholder="Zoek item..." value={searchQuery}
                onChange={e=>setSearchQuery(e.target.value)}/>
              <button onClick={()=>{setSearchOpen(false);setSearchQuery('');}}
                style={{background:'none',border:'none',color:'#7A8899',cursor:'pointer',fontSize:16,padding:'0 4px',WebkitTapHighlightColor:'transparent'}}>✕</button>
            </div>

            {/* ── Single day list ── */}
            <div style={{flex:1,overflowY:'auto'}}>
              {rows.length===0&&(
                <div style={{padding:'60px 20px',textAlign:'center',color:C.txt3}}>
                  <div style={{fontSize:32,marginBottom:12}}>{showArchive?'📦':'📋'}</div>
                  <div style={{fontSize:14,fontWeight:600,color:C.txt2,marginBottom:6}}>{showArchive?'Archief is leeg':'Nog geen items'}</div>
                  <div style={{fontSize:12}}>{showArchive?'Gearchiveerde items verschijnen hier.':'Voeg items toe via de knop onderaan, of voeg een recept toe via Nieuw recept'}</div>
                </div>
              )}
              {rows.map(row=>row.type==='cat'?(
                <div key={`c-${row.cat}`} className="cat-header">
                  <span className="cat-name">{row.cat}</span>
                  {(()=>{
                    const catItems = dept?.items?.filter(i=>i.category===row.cat&&!i.archived)||[];
                    const done = catItems.filter(i=>(i.checks?.[selectedDay]||0)===2).length;
                    const total = catItems.length;
                    const allDone = done===total&&total>0;
                    return <span className={`cat-count${allDone?' all-done':''}`}>{done}/{total}{allDone?' ✓':''}</span>;
                  })()}
                </div>
              ):(
                <div key={`i-${row.item.id}`} className={`irow ${selId===row.item.id?'irow-sel':''}`}>
                  {/* Checkbox */}
                  {(()=>{
                    const st=row.item.checks[selectedDay]||0;
                    const d=selectedDay;
                    const di=DAYS.indexOf(d);
                    return (
                      <span className={`chk chk-${st}`}
                        onClick={()=>toggleCheck(row.item.id,d)}
                        onTouchStart={e=>{
                          const t=e.currentTarget;
                          t._tx=e.touches[0].clientX; t._ty=e.touches[0].clientY;
                          t._lp=setTimeout(()=>{
                            if(window.navigator?.vibrate) window.navigator.vibrate(40);
                            toggleCheck(row.item.id,d); t._lp=null;
                          },400);
                        }}
                        onTouchMove={e=>{
                          const t=e.currentTarget;
                          const dx=Math.abs(e.touches[0].clientX-(t._tx||0));
                          const dy=Math.abs(e.touches[0].clientY-(t._ty||0));
                          if(dx>8||dy>8){ clearTimeout(t._lp); t._lp=null; }
                        }}
                        onTouchEnd={e=>{
                          const t=e.currentTarget;
                          if(t._lp){ clearTimeout(t._lp); t._lp=null; }
                          else { e.preventDefault(); }
                        }}>
                        {st===1&&'✕'}{st===2&&'✓'}
                      </span>
                    );
                  })()}
                  {/* Item name + tags */}
                  <div style={{flex:1,minWidth:0,cursor:'pointer'}} onClick={()=>openItem(row.item.id)}>
                    <div className="iname" style={{fontSize:14,fontWeight:500,color:row.item.archived?C.txt3:C.txt,lineHeight:1.3,textDecoration:(row.item.checks[selectedDay]||0)===2?'line-through':'none',opacity:(row.item.checks[selectedDay]||0)===2?0.6:1}}>{row.item.name}</div>
                    <div style={{display:'flex',gap:4,marginTop:3,flexWrap:'wrap'}}>
                      {row.item.recipe&&<span className="item-tag tag-recept">recept</span>}
                      {row.item.allergenen?.length>0&&<span className="item-tag tag-allergen">{row.item.allergenen.length} allergenen</span>}
                      {row.item.archived&&<span className="item-tag" style={{background:'rgba(201,159,59,.12)',color:C.amber}}>archief</span>}
                      {row.item.notes?.[selectedDay]&&<span style={{fontSize:10,color:C.amber}}>✎ notitie</span>}
                    </div>
                  </div>
                  {/* Push button */}
                  {(row.item.checks[selectedDay]||0)===1&&(()=>{
                    // dayKey-formaat: "YYYY-Www-Dd" — laatste segment na de '-' is de dagcode
                    const dayName = selectedDay.split('-').pop();
                    const di2 = DAYS.indexOf(dayName);
                    if (di2 < 0) return null; // veiligheid: onbekende dayKey
                    const isLast2 = di2 >= DAYS.length-1;
                    const nextLabel = isLast2 ? DAYS[0]+'(+1)' : DAYS[di2+1];
                    return <button style={{fontSize:10,background:'none',border:`1px solid ${C.amberBd}`,color:C.amber,padding:'3px 6px',cursor:'pointer',fontFamily:'inherit',borderRadius:4,flexShrink:0,WebkitTapHighlightColor:'transparent'}} onClick={e=>{e.stopPropagation();pushDay(row.item.id,di2);}}>→{nextLabel}</button>;
                  })()}
                  {/* Icon btn */}
                  <button className="icon-btn delete" title="Verwijderen" onClick={e=>{e.stopPropagation();if(!window.confirm(`"${row.item.name}" verwijderen?`))return;updItems(its=>its.filter(i=>i.id!==row.item.id));if(selId===row.item.id)closePanel();}}>×</button>
                </div>
              ))}
            </div>
            {/* Add-balk: alleen zichtbaar wanneer een invoerveld geopend wordt via het menu */}
            {(addingCat || addingItem) && (
              <div style={{flexShrink:0,padding:'10px 14px',borderTop:`1px solid ${C.bdr}`,background:C.bg2}}>
                {addingCat && (
                  <div style={{display:'flex',gap:7,marginBottom:addingItem?8:0}}>
                    <input autoFocus style={{flex:1,background:'#fff',border:`1px solid ${C.amberBd}`,color:C.txt,padding:'6px 10px',fontFamily:'inherit',fontSize:12,outline:'none',borderRadius:4}}
                      placeholder="Naam nieuwe categorie"
                      value={newCatName}
                      onChange={e=>setNewCatName(e.target.value)}
                      onKeyDown={e=>{
                        if(e.key==='Enter'&&newCatName.trim()&&!allCats.includes(newCatName.trim())){
                          setCustomCats(c=>[...c,newCatName.trim()]);
                          setNewCatName(''); setAddingCat(false);
                        }
                      }}
                    />
                    <button style={{background:C.amber,border:'none',color:'#fff',padding:'6px 14px',fontFamily:'inherit',fontSize:12,fontWeight:600,cursor:'pointer',borderRadius:4}}
                      onClick={()=>{
                        if(newCatName.trim()&&!allCats.includes(newCatName.trim())){
                          setCustomCats(c=>[...c,newCatName.trim()]);
                          setNewCatName(''); setAddingCat(false);
                        }
                      }}>+ Toevoegen</button>
                    <button style={{background:'transparent',border:`1px solid ${C.bdr}`,color:C.txt2,padding:'6px 10px',fontFamily:'inherit',cursor:'pointer',borderRadius:4}}
                      onClick={()=>{setAddingCat(false);setNewCatName('');}}>✕</button>
                  </div>
                )}
                {addingItem && (
                  <div style={{display:'flex',gap:7,alignItems:'stretch'}}>
                    <input autoFocus style={{flex:1,background:'#fff',border:`1px solid ${C.amberBd}`,color:C.txt,padding:'6px 10px',fontFamily:'inherit',fontSize:12,outline:'none',borderRadius:4,minWidth:0}} placeholder="Naam nieuw item" value={newForm.name} onChange={e=>setNewForm(f=>({...f,name:e.target.value}))} onKeyDown={e=>e.key==='Enter'&&submitNew()}/>
                    <select style={{background:'#fff',border:`1px solid ${C.bdr}`,color:C.txt2,padding:'6px 8px',fontFamily:'inherit',fontSize:11,outline:'none',cursor:'pointer',borderRadius:4}} value={newForm.category} onChange={e=>setNewForm(f=>({...f,category:e.target.value}))}>
                      {allCats.map(c=><option key={c} value={c}>{c}</option>)}
                    </select>
                    <button style={{background:C.amber,border:'none',color:'#fff',padding:'6px 14px',fontFamily:'inherit',fontSize:12,fontWeight:600,cursor:'pointer',borderRadius:4,opacity:newForm.name.trim()?1:0.4}} onClick={submitNew} disabled={!newForm.name.trim()}>+ Toevoegen</button>
                    <button style={{background:'transparent',border:`1px solid ${C.bdr}`,color:C.txt2,padding:'6px 10px',fontFamily:'inherit',cursor:'pointer',borderRadius:4}} onClick={()=>setAddingItem(false)}>✕</button>
                  </div>
                )}
              </div>
            )}
          </>):null}

          {/* ══ Receptenboek view ══════════════════════════════════════════ */}
          {view==='recipes' && (() => {
            const filtered = recipes
              .filter(r => recipeShowArchived ? r.archived : !r.archived)
              .filter(r => recipeCatFilter === 'alle' || r.category === recipeCatFilter)
              .filter(r => {
                if (!recipeSearch.trim()) return true;
                const q = recipeSearch.trim().toLowerCase();
                return (r.name||'').toLowerCase().includes(q)
                    || (r.recipe||'').toLowerCase().includes(q)
                    || (r.ingredients||[]).some(i => (i.name||'').toLowerCase().includes(q));
              })
              .sort((a,b) => (a.name||'').localeCompare(b.name||''));

            // Tel hoe vaak een recept gepland staat
            const usageCount = (rid) => depts.reduce((n, d) =>
              n + d.items.filter(it => it.recipe_id === rid && !it.archived).length, 0);

            return (
              <>
                {/* Toolbar */}
                <div style={{background:'#fff',borderBottom:'1px solid #E4DFD7',padding:'12px 16px',flexShrink:0,display:'flex',gap:8,flexWrap:'wrap',alignItems:'center'}}>
                  <div style={{flex:1,minWidth:200,position:'relative'}}>
                    <input
                      type="text"
                      placeholder="🔍 Zoek recept, ingrediënt..."
                      value={recipeSearch}
                      onChange={e=>setRecipeSearch(e.target.value)}
                      style={{width:'100%',background:'#fff',border:`1px solid ${C.bdr}`,color:C.txt,padding:'7px 12px',fontFamily:'inherit',fontSize:13,outline:'none',borderRadius:6}}
                    />
                  </div>
                  <select
                    value={recipeCatFilter}
                    onChange={e=>setRecipeCatFilter(e.target.value)}
                    style={{background:'#fff',border:`1px solid ${C.bdr}`,color:C.txt2,padding:'7px 10px',fontFamily:'inherit',fontSize:12,outline:'none',cursor:'pointer',borderRadius:6}}
                  >
                    <option value="alle">Alle categorieën</option>
                    {allCats.map(c => <option key={c} value={c}>{c}</option>)}
                  </select>
                  <button
                    onClick={()=>setRecipeShowArchived(v=>!v)}
                    style={{background:recipeShowArchived?C.amberBg:'transparent',border:`1px solid ${recipeShowArchived?C.amberBd:C.bdr}`,color:recipeShowArchived?C.amber:C.txt2,padding:'7px 12px',fontFamily:'inherit',fontSize:12,cursor:'pointer',borderRadius:6}}
                    title={recipeShowArchived?'Toon actieve recepten':'Toon archief'}
                  >
                    {recipeShowArchived?'📁 Archief aan':'📁 Archief'}
                  </button>
                  <button
                    onClick={()=>setShowCatManager(true)}
                    style={{background:'transparent',border:`1px solid ${C.bdr}`,color:C.txt2,padding:'7px 12px',fontFamily:'inherit',fontSize:12,cursor:'pointer',borderRadius:6}}
                    title="Categorieën beheren"
                  >
                    🗂 Categorieën
                  </button>
                  <button
                    onClick={()=>setPasteMode(true)}
                    style={{background:C.amber,border:'none',color:'#0D1B38',padding:'7px 14px',fontFamily:'inherit',fontSize:12,fontWeight:600,cursor:'pointer',borderRadius:6}}
                  >
                    + Nieuw recept
                  </button>
                </div>

                {/* Lijst */}
                <div style={{flex:1,overflowY:'auto',padding:'8px 0 60px'}}>
                  {filtered.length === 0 ? (
                    <div style={{padding:'40px 16px',textAlign:'center',color:C.txt3}}>
                      <div style={{fontSize:34,marginBottom:8}}>📖</div>
                      <div style={{fontSize:13}}>
                        {recipeSearch || recipeCatFilter !== 'alle'
                          ? 'Geen recepten gevonden met deze filters.'
                          : recipeShowArchived
                            ? 'Geen gearchiveerde recepten.'
                            : 'Nog geen recepten. Voeg er één toe via "+ Nieuw recept".'}
                      </div>
                    </div>
                  ) : filtered.map(r => {
                    const used = usageCount(r.id);
                    return (
                      <div key={r.id}
                        onClick={()=>openRecipe(r.id)}
                        style={{
                          display:'flex',alignItems:'center',gap:10,
                          padding:'12px 16px',
                          borderBottom:`1px solid ${C.bdr}`,
                          cursor:'pointer',
                          background:'#fff',
                          transition:'background .12s',
                        }}
                        onMouseEnter={e=>e.currentTarget.style.background='#FAF7F0'}
                        onMouseLeave={e=>e.currentTarget.style.background='#fff'}
                      >
                        <div style={{flex:1,minWidth:0}}>
                          <div style={{fontSize:14,fontWeight:600,color:C.txt,marginBottom:2}}>{r.name||'(naamloos)'}</div>
                          <div style={{fontSize:11,color:C.txt3,display:'flex',gap:10,flexWrap:'wrap',alignItems:'center'}}>
                            <span>{r.category||'—'}</span>
                            {r.ingredients?.length > 0 && <span>· {r.ingredients.length} ingrediënt{r.ingredients.length===1?'':'en'}</span>}
                            {r.allergenen?.length > 0 && <span style={{color:C.red}}>· {r.allergenen.length===1 ? '1 allergeen' : `${r.allergenen.length} allergenen`}</span>}
                          </div>
                        </div>
                        {used > 0 && (
                          <span style={{fontSize:10,background:C.amberBg,color:C.amber,border:`1px solid ${C.amberBd}`,padding:'2px 8px',borderRadius:10,fontWeight:600}}>
                            {used}× gepland
                          </span>
                        )}
                        <span style={{color:C.txt3,fontSize:14}}>›</span>
                      </div>
                    );
                  })}
                </div>
              </>
            );
          })()}
        </div>

        {/* Detail panel */}
        {selId&&cur&&(
          <div className="overlay" onClick={()=>closePanel()}>
          <div className="detail-sheet" onClick={e=>e.stopPropagation()} style={{position:'relative'}}>
            <div className="sheet-handle"/>
            <div style={{padding:'13px 16px',borderBottom:`1px solid ${C.bdr}`,display:'flex',gap:10,alignItems:'flex-start',flexShrink:0}}>
              <button className="btn-back" style={{background:'none',border:`1px solid ${C.bdr}`,color:C.txt2,fontSize:16,cursor:'pointer',padding:'2px 8px',flexShrink:0,marginTop:2,lineHeight:1,fontFamily:'inherit',borderRadius:4}} onClick={closePanel}>←</button>
              <div style={{flex:1,minWidth:0}}>
                {editing?(<>
                  <input style={{width:'100%',background:'transparent',border:'none',borderBottom:`2px solid ${C.amber}`,color:C.txt,fontFamily:'inherit',fontSize:15,fontWeight:700,padding:'2px 0',outline:'none'}} value={draft.name} onChange={e=>setDraft(d=>({...d,name:e.target.value}))}/>
                  <select style={{background:'transparent',border:'none',borderBottom:`1px solid ${C.bdr}`,color:C.txt2,fontFamily:'inherit',fontSize:11,padding:'3px 0',marginTop:4,outline:'none',cursor:'pointer'}} value={draft.category} onChange={e=>setDraft(d=>({...d,category:e.target.value}))}>
                    {allCats.map(c=><option key={c} value={c}>{c}</option>)}
                  </select>
                </>):(<>
                  <div style={{fontSize:15,fontWeight:700,color:C.txt,wordBreak:'break-word'}}>{cur.name}</div>
                  <div style={{fontSize:11,color:C.txt2,marginTop:4}}>{CAT_ICONS[cur.category]} {cur.category}</div>
                </>)}
              </div>
            </div>

            <div style={{flex:1,overflowY:'auto',padding:16,display:'flex',flexDirection:'column',gap:18}}>
              {/* Recept-koppeling */}
              <div>
                <div style={{fontSize:10,letterSpacing:1,color:C.txt2,marginBottom:8,fontWeight:600,textTransform:'uppercase'}}>Gekoppeld recept</div>
                {editing ? (
                  <select
                    value={draft.recipe_id || ''}
                    onChange={e=>{
                      const val = e.target.value ? Number(e.target.value) : null;
                      setDraft(d => {
                        if (!val) {
                          // Ontkoppelen: behoud eventueel laatst bekende inhoud als item-eigen
                          const { recipe_id, ...rest } = d;
                          return { ...rest, recipe_id: null };
                        }
                        // Koppelen: leeg de item-eigen recept-velden zodat het recept leidend wordt
                        return { ...d, recipe_id: val, recipe:'', ingredients:[], allergenen:[], tht_dagen:null, bewaaradvies:'' };
                      });
                    }}
                    style={{width:'100%',background:'#FAFAF8',border:`1px solid ${C.bdr}`,color:C.txt,padding:'7px 10px',fontFamily:'inherit',fontSize:13,outline:'none',borderRadius:4,cursor:'pointer'}}
                  >
                    <option value="">— Geen recept (eigen inhoud) —</option>
                    {recipes.filter(r=>!r.archived).sort((a,b)=>(a.name||'').localeCompare(b.name||'')).map(r => (
                      <option key={r.id} value={r.id}>{r.name}</option>
                    ))}
                  </select>
                ) : (
                  cur.recipe_id && cur._recipeName ? (
                    <div style={{display:'flex',alignItems:'center',gap:8}}>
                      <span style={{fontSize:13,color:C.amber,fontWeight:600}}>📖 {cur._recipeName}</span>
                      <button
                        onClick={()=>{ const r = recipes.find(x=>x.id===cur.recipe_id); if(r){ setView('recipes'); openRecipe(r.id); closePanel(); } }}
                        style={{background:'transparent',border:`1px solid ${C.bdr}`,color:C.txt2,padding:'3px 9px',fontFamily:'inherit',fontSize:11,cursor:'pointer',borderRadius:4}}
                      >Bekijk recept ›</button>
                    </div>
                  ) : (
                    <span style={{fontSize:12,color:C.txt3,fontStyle:'italic'}}>Geen recept gekoppeld — eigen inhoud.</span>
                  )
                )}
              </div>

              {/* Bereiding */}
              <div>
                <div style={{fontSize:10,letterSpacing:1,color:C.txt2,marginBottom:8,fontWeight:600,textTransform:'uppercase'}}>
                  Bereiding {cur.recipe_id && <span style={{fontWeight:400,color:C.txt3,textTransform:'none',letterSpacing:0}}>(uit recept)</span>}
                </div>
                {editing && !draft.recipe_id ? (
                  <textarea style={{width:'100%',background:'#FAFAF8',border:`1px solid ${C.bdr}`,color:C.txt,fontFamily:'inherit',fontSize:13,lineHeight:1.6,padding:10,resize:'vertical',outline:'none',minHeight:100,borderRadius:4}} value={draft.recipe} rows={4} onChange={e=>setDraft(d=>({...d,recipe:e.target.value}))} placeholder="Beschrijf de bereidingswijze..."/>
                ):(
                  <div style={{fontSize:13,color:cur.recipe?C.txt:C.txt3,lineHeight:1.7,whiteSpace:'pre-wrap',fontStyle:cur.recipe?'normal':'italic'}}>{cur.recipe||(cur.recipe_id?'Recept heeft geen bereidingstekst.':'Geen recept. Klik Bewerken.')}</div>
                )}
              </div>

              {/* Ingrediënten */}
              <div>
                <div style={{fontSize:10,letterSpacing:1,color:C.txt2,marginBottom:8,fontWeight:600,textTransform:'uppercase'}}>Ingrediënten {cur.ingredients.length>0&&<span style={{fontWeight:400,color:C.txt3}}>({cur.ingredients.length})</span>}{cur.recipe_id && <span style={{fontWeight:400,color:C.txt3,textTransform:'none',letterSpacing:0}}> (uit recept)</span>}</div>
                {!editing&&cur.ingredients.length===0&&<span style={{fontSize:12,color:C.txt3,fontStyle:'italic'}}>Geen ingrediënten. Klik Bewerken.</span>}
                <div style={{display:'flex',flexDirection:'column',gap:4}}>
                  {((editing && !draft.recipe_id)?draft.ingredients:cur.ingredients).map(ing=>(editing && !draft.recipe_id)?(
                    <div key={ing.id} style={{display:'flex',alignItems:'center',gap:4,marginBottom:2,flexWrap:'wrap'}}>
                      <input style={{flex:2,minWidth:80,background:'#FAFAF8',border:`1px solid ${C.bdr}`,color:C.txt,padding:'4px 8px',fontFamily:'inherit',fontSize:12,outline:'none',borderRadius:4}} value={ing.name} placeholder="Ingrediënt" onChange={e=>setDraft(d=>({...d,ingredients:d.ingredients.map(i=>i.id===ing.id?{...i,name:e.target.value}:i)}))}/>
                      <input type="number" min="0" style={{width:50,background:'#FAFAF8',border:`1px solid ${C.bdr}`,color:C.txt,padding:'4px 6px',fontFamily:'inherit',fontSize:12,outline:'none',textAlign:'right',borderRadius:4}} value={ing.amount} placeholder="0" onChange={e=>setDraft(d=>({...d,ingredients:d.ingredients.map(i=>i.id===ing.id?{...i,amount:e.target.value}:i)}))}/>
                      <select style={{background:'#FAFAF8',border:`1px solid ${C.bdr}`,color:C.txt2,padding:'4px 3px',fontFamily:'inherit',fontSize:11,outline:'none',borderRadius:4}} value={ing.unit} onChange={e=>setDraft(d=>({...d,ingredients:d.ingredients.map(i=>i.id===ing.id?{...i,unit:e.target.value}:i)}))}>
                        {UNITS.map(u=><option key={u} value={u}>{u}</option>)}
                      </select>
                      <select style={{background:'#FAFAF8',border:`1px solid ${C.bdr}`,color:C.txt2,padding:'4px 3px',fontFamily:'inherit',fontSize:11,outline:'none',borderRadius:4}} value={ing.supplier||'Overig'} onChange={e=>setDraft(d=>({...d,ingredients:d.ingredients.map(i=>i.id===ing.id?{...i,supplier:e.target.value}:i)}))}>
                        {SUPPLIERS.map(s=><option key={s} value={s}>{s}</option>)}
                      </select>
                      <button className="btn-iedel" style={{background:'none',border:'none',color:C.txt3,cursor:'pointer',fontSize:13,padding:'0 4px',fontFamily:'inherit'}} onClick={()=>setDraft(d=>({...d,ingredients:d.ingredients.filter(i=>i.id!==ing.id)}))}>✕</button>
                    </div>
                  ):(
                    <div key={ing.id} style={{display:'flex',alignItems:'center',gap:8,padding:'5px 0',borderBottom:`1px solid #EEE9E2`}}>
                      <span style={{color:C.txt3,fontSize:12}}>—</span>
                      <span style={{flex:1,fontSize:13,color:C.txt}}>{ing.name}</span>
                      <span style={{fontSize:11,color:C.txt3}}>{ing.supplier||'Overig'}</span>
                      <span style={{fontSize:12,color:C.amber,fontWeight:600,whiteSpace:'nowrap'}}>{ing.amount} {ing.unit}</span>
                    </div>
                  ))}
                  {editing&&!draft.recipe_id&&<button className="btn-adding" style={{background:'transparent',border:`1px dashed ${C.bdr2}`,color:C.txt2,padding:'5px 10px',fontFamily:'inherit',fontSize:11,cursor:'pointer',textAlign:'left',marginTop:4,borderRadius:4,width:'100%'}} onClick={()=>setDraft(d=>({...d,ingredients:[...d.ingredients,{id:uid(),name:'',amount:'',unit:'g',supplier:'Overig'}]}))}>+ Ingrediënt toevoegen</button>}
                </div>
              </div>

              {/* HACCP: THT / Allergenen / Bewaaradvies */}
              <div>
                <div className='sheet-label'>HACCP & Etiket</div>
                {editing && draft.recipe_id ? (
                  <div style={{fontSize:12,color:C.txt3,fontStyle:'italic',padding:'8px 0'}}>
                    THT, bewaaradvies en allergenen komen uit het gekoppelde recept. Bewerk ze via het Receptenboek.
                  </div>
                ) : editing ? (<>
                  {/* THT */}
                  <div style={{marginBottom:8}}>
                    <label style={{fontSize:11,color:C.txt2,display:'block',marginBottom:3}}>THT termijn (dagen vanaf productie)</label>
                    <div style={{display:'flex',alignItems:'center',gap:8}}>
                      <input type="number" min="1" max="30" style={{width:70,background:'#FAFAF8',border:`1px solid ${C.bdr}`,color:C.txt,padding:'5px 8px',fontFamily:'inherit',fontSize:12,outline:'none',borderRadius:4}}
                        placeholder="Dagen"
                        value={draft.tht_dagen||''}
                        onChange={e=>setDraft(d=>({...d,tht_dagen:e.target.value?parseInt(e.target.value):null}))}
                      />
                      <span style={{fontSize:11,color:C.txt3}}>dagen (leeg = geen THT op etiket)</span>
                    </div>
                  </div>
                  {/* Bewaaradvies */}
                  <div style={{marginBottom:8}}>
                    <label style={{fontSize:11,color:C.txt2,display:'block',marginBottom:3}}>Bewaaradvies</label>
                    <select style={{background:'#FAFAF8',border:`1px solid ${C.bdr}`,color:C.txt,padding:'5px 8px',fontFamily:'inherit',fontSize:12,outline:'none',borderRadius:4,width:'100%'}}
                      value={draft.bewaaradvies||''}
                      onChange={e=>setDraft(d=>({...d,bewaaradvies:e.target.value}))}>
                      {BEWAARADVIES.map(b=><option key={b||'(geen)'} value={b}>{b||'— geen bewaaradvies —'}</option>)}
                    </select>
                  </div>
                  {/* Allergenen */}
                  <div>
                    <label style={{fontSize:11,color:C.txt2,display:'block',marginBottom:5}}>Aanwezige allergenen</label>
                    <div style={{display:'flex',flexWrap:'wrap',gap:5}}>
                      {ALLERGENEN.map(a=>{
                        const isGluten = a==='Gluten';
                        const isNoten  = a==='Noten';
                        // Check if any sub-variant of this allergen is selected
                        const subSel = isGluten ? GLUTEN_SUB.filter(s=>(draft.allergenen||[]).includes(s)) :
                                       isNoten  ? NOTEN_SUB.filter(s=>(draft.allergenen||[]).includes(s)) : [];
                        const sel = isGluten||isNoten ? subSel.length>0 : (draft.allergenen||[]).includes(a);
                        const label = isGluten&&subSel.length>0 ? subSel.join(', ') :
                                      isNoten&&subSel.length>0  ? subSel.join(', ') : a;
                        return (<div key={a} style={{position:'relative',display:'inline-block'}}>
                          <button type="button"
                            style={{padding:'3px 8px',fontSize:11,fontFamily:'inherit',cursor:'pointer',borderRadius:10,border:`1px solid ${sel?C.red:C.bdr}`,background:sel?'#FFE9E9':'transparent',color:sel?C.red:C.txt2,fontWeight:sel?700:400}}
                            onClick={()=>{
                              if(isGluten){setGlutenOpen(o=>!o);return;}
                              if(isNoten){setNotenOpen(o=>!o);return;}
                              setDraft(d=>({...d,allergenen:sel?(d.allergenen||[]).filter(x=>x!==a):[...(d.allergenen||[]),a]}));
                            }}>
                            {label}{(isGluten||isNoten)?' ▾':''}
                          </button>
                          {/* Gluten submenu */}
                          {isGluten&&glutenOpen&&(
                            <div style={{position:'absolute',top:'100%',left:0,background:'#fff',border:`1px solid ${C.bdr}`,borderRadius:6,padding:6,zIndex:50,minWidth:140,boxShadow:'0 4px 12px rgba(0,0,0,.1)'}}>
                              {GLUTEN_SUB.map(s=>{
                                const ss=(draft.allergenen||[]).includes(s);
                                return <div key={s} style={{padding:'4px 8px',cursor:'pointer',borderRadius:4,background:ss?'#FFE9E9':'transparent',color:ss?C.red:C.txt,fontSize:12}}
                                  onClick={()=>setDraft(d=>({...d,allergenen:ss?(d.allergenen||[]).filter(x=>x!==s):[...(d.allergenen||[]).filter(x=>!GLUTEN_SUB.includes(x)&&x!=='Gluten'),s]}))}>
                                  {ss?'✓ ':''}{s}</div>;
                              })}
                              <div style={{borderTop:`1px solid ${C.bdr}`,marginTop:4,paddingTop:4,padding:'4px 8px',cursor:'pointer',color:C.txt3,fontSize:11}} onClick={()=>{setGlutenOpen(false);setDraft(d=>({...d,allergenen:(d.allergenen||[]).filter(x=>!GLUTEN_SUB.includes(x)&&x!=='Gluten')}));}}>Wis Gluten</div>
                            </div>
                          )}
                          {/* Noten submenu */}
                          {isNoten&&notenOpen&&(
                            <div style={{position:'absolute',top:'100%',left:0,background:'#fff',border:`1px solid ${C.bdr}`,borderRadius:6,padding:6,zIndex:50,minWidth:160,boxShadow:'0 4px 12px rgba(0,0,0,.1)'}}>
                              {NOTEN_SUB.map(s=>{
                                const ss=(draft.allergenen||[]).includes(s);
                                return <div key={s} style={{padding:'4px 8px',cursor:'pointer',borderRadius:4,background:ss?'#FFE9E9':'transparent',color:ss?C.red:C.txt,fontSize:12}}
                                  onClick={()=>setDraft(d=>({...d,allergenen:ss?(d.allergenen||[]).filter(x=>x!==s):[...(d.allergenen||[]).filter(x=>!NOTEN_SUB.includes(x)&&x!=='Noten'),s]}))}>
                                  {ss?'✓ ':''}{s}</div>;
                              })}
                              <div style={{borderTop:`1px solid ${C.bdr}`,marginTop:4,paddingTop:4,padding:'4px 8px',cursor:'pointer',color:C.txt3,fontSize:11}} onClick={()=>{setNotenOpen(false);setDraft(d=>({...d,allergenen:(d.allergenen||[]).filter(x=>!NOTEN_SUB.includes(x)&&x!=='Noten')}));}}>Wis Noten</div>
                            </div>
                          )}
                        </div>);
                      })}
                    </div>
                  </div>
                </>) : (<>
                  {cur.tht_dagen && <div style={{fontSize:12,color:C.txt,marginBottom:4}}>⏱ THT: <b>{cur.tht_dagen} dagen</b> na productie</div>}
                  {cur.bewaaradvies && <div style={{fontSize:12,color:C.txt,marginBottom:4}}>❄ {cur.bewaaradvies}</div>}
                  {cur.allergenen?.length>0 && (
                    <div style={{display:'flex',flexWrap:'wrap',gap:4,marginTop:4}}>
                      {cur.allergenen.map(a=><span key={a} style={{background:'#FFE9E9',border:'1px solid #F0AAAA',color:C.red,fontSize:10,padding:'2px 7px',borderRadius:10,fontWeight:600}}>{a}</span>)}
                    </div>
                  )}
                  {!cur.tht_dagen && !cur.allergenen?.length && <span style={{fontSize:12,color:C.txt3,fontStyle:'italic'}}>Geen HACCP info. Klik Bewerken.</span>}
                </>)}
              </div>

              {/* Dagnotities */}
              <div>
                <div style={{fontSize:10,letterSpacing:1,color:C.txt2,marginBottom:8,fontWeight:600,textTransform:'uppercase'}}>Dagnotities</div>
                {editing?(
                  <div style={{display:'flex',flexDirection:'column',gap:5}}>
                    {DAYS.map(d=>(
                      <div key={d} style={{display:'flex',alignItems:'center',gap:8}}>
                        <span style={{fontSize:11,color:C.txt2,width:22,flexShrink:0,fontWeight:600}}>{d}</span>
                        <input style={{flex:1,background:'#FAFAF8',border:`1px solid ${C.bdr}`,color:C.txt,padding:'4px 8px',fontFamily:'inherit',fontSize:12,outline:'none',borderRadius:4}} value={draft.notes?.[d]||''} placeholder="Notitie voor deze dag…" onChange={e=>setDraft(d2=>({...d2,notes:{...d2.notes,[d]:e.target.value}}))}/>
                      </div>
                    ))}
                  </div>
                ):(
                  <div style={{display:'flex',flexDirection:'column',gap:4}}>
                    {DAYS.filter(d=>cur.notes?.[d]).map(d=>(
                      <div key={d} style={{display:'flex',gap:8,padding:'4px 0',borderBottom:`1px solid #EEE9E2`}}>
                        <span style={{fontSize:11,color:C.txt2,width:22,flexShrink:0,fontWeight:600}}>{d}</span>
                        <span style={{fontSize:12,color:C.txt}}>{cur.notes[d]}</span>
                      </div>
                    ))}
                    {!Object.values(cur.notes||{}).some(Boolean)&&<span style={{fontSize:12,color:C.txt3,fontStyle:'italic'}}>Geen notities. Klik Bewerken.</span>}
                  </div>
                )}
              </div>
            </div>

            {/* Etiket print modal */}
            {printEtiket&&cur&&(()=>{
              // ── Productiedatum: gekozen datum of vandaag ──────────────────
              const prodDate = etikProdDatum ? new Date(etikProdDatum + 'T12:00:00') : new Date();
              const isToday = !etikProdDatum || etikProdDatum === new Date().toISOString().slice(0,10);
              const fmtDatum = (d) => d.toLocaleDateString('nl-NL');
              const fmtTijd  = (d) => d.toLocaleTimeString('nl-NL',{hour:'2-digit',minute:'2-digit'});
              // THT-datum = productiedatum + tht_dagen + eventuele verlenging
              const thtDate = cur.tht_dagen ? (()=>{ const d=new Date(prodDate); d.setDate(d.getDate()+(cur.tht_dagen||0)+(etikExtra||0)); return d; })() : null;
              const thtStr  = thtDate ? fmtDatum(thtDate) : null;
              // Tijd: bij datum in verleden geen "nu"-tijd tonen (zou verwarrend zijn)
              const tijdStr = isToday ? fmtTijd(new Date()) : '';

              const doePrint = async () => {
                const printData = {
                  bedrijfsnaam: CONFIG.bedrijfsnaam,
                  product:      cur.name,
                  categorie:    cur.category||'',
                  datum:        fmtDatum(prodDate),
                  tijd:         tijdStr,
                  tht:          thtStr||'',
                  medewerker:   etikMed||'',
                  allergenen:   cur.allergenen||[],
                  bewaaradvies: cur.bewaaradvies||'',
                };
                try {
                  const resp = await fetch(`${CONFIG.printServerUrl}/print`, {
                    method: 'POST',
                    headers: {'Content-Type':'application/json'},
                    body: JSON.stringify(printData),
                  });
                  const result = await resp.json();
                  if (result.ok) { alert('✓ Label wordt geprint!'); }
                  else { alert('Print fout: ' + result.error); }
                } catch(err) {
                  if (err.message?.includes('Failed to fetch') || err.message?.includes('NetworkError')) {
                    alert('Kan print server niet bereiken.\n\nMogelijke oorzaken:\n1. Print server draait niet (start start-print-server.bat)\n2. Tunnel is verlopen\n3. Verkeerd IP adres in CONFIG');
                  } else {
                    alert('Print fout: ' + err.message);
                  }
                }
                setPrintEtiket(false); setEtikExtra(0); setEtikProdDatum('');
              };

              return (
              <div style={{position:'fixed',inset:0,zIndex:9999,background:'rgba(13,27,56,0.75)',display:'flex',alignItems:'flex-end',justifyContent:'center'}}>
                <div style={{background:'#fff',borderRadius:'16px 16px 0 0',width:'100%',maxWidth:480,padding:20,display:'flex',flexDirection:'column',gap:12,maxHeight:'90vh',overflowY:'auto'}}>
                  <div className="sheet-handle"/>
                  <div style={{display:'flex',justifyContent:'space-between',alignItems:'center'}}>
                    <div style={{fontSize:14,fontWeight:700,color:'#0D1B38'}}>Etiket printen</div>
                    <button style={{background:'none',border:'none',color:C.txt3,cursor:'pointer',fontSize:18}} onClick={()=>{setPrintEtiket(false);setEtikExtra(0);setEtikProdDatum('');}}>×</button>
                  </div>
                  <div style={{fontSize:12,color:'#3D5A99'}}>Product: <b>{cur.name}</b></div>
                  {/* Productiedatum */}
                  <div>
                    <label style={{fontSize:11,color:'#3D5A99',display:'block',marginBottom:3}}>Productiedatum</label>
                    <div style={{display:'flex',alignItems:'center',gap:8,flexWrap:'wrap'}}>
                      <input type="date"
                        max={new Date().toISOString().slice(0,10)}
                        value={etikProdDatum || new Date().toISOString().slice(0,10)}
                        onChange={e=>setEtikProdDatum(e.target.value)}
                        style={{background:'#fff',border:'1px solid #BCCEFB',color:'#0C1835',padding:'5px 8px',fontFamily:'inherit',fontSize:12,outline:'none',borderRadius:4}}/>
                      {!isToday && (
                        <button onClick={()=>setEtikProdDatum('')}
                          style={{background:'transparent',border:'1px solid #BCCEFB',color:'#3D5A99',padding:'5px 10px',fontFamily:'inherit',fontSize:11,cursor:'pointer',borderRadius:4}}>
                          → Vandaag
                        </button>
                      )}
                      {!isToday && <span style={{fontSize:10,color:'#C03030',fontWeight:600}}>⚠ Datum in verleden</span>}
                    </div>
                  </div>
                  {/* Medewerker */}
                  <div>
                    <label style={{fontSize:11,color:'#3D5A99',display:'block',marginBottom:3}}>Gemaakt door</label>
                    <select style={{background:'#fff',border:'1px solid #BCCEFB',color:'#0C1835',padding:'6px 10px',fontFamily:'inherit',fontSize:12,outline:'none',borderRadius:4,width:'100%'}}
                      value={etikMed} onChange={e=>setEtikMed(e.target.value)}>
                      <option value="">Kies medewerker…</option>
                      {medewerkers.map(m=><option key={m.id} value={m.naam}>{m.naam}</option>)}
                    </select>
                  </div>
                  {/* THT verlenging */}
                  {cur.tht_dagen&&(
                    <div>
                      <label style={{fontSize:11,color:'#3D5A99',display:'block',marginBottom:3}}>THT verlenging (extra dagen)</label>
                      <div style={{display:'flex',alignItems:'center',gap:8}}>
                        <input type="number" min="0" max="7" style={{width:60,background:'#fff',border:'1px solid #BCCEFB',color:'#0C1835',padding:'5px 8px',fontFamily:'inherit',fontSize:12,outline:'none',borderRadius:4}}
                          value={etikExtra} onChange={e=>setEtikExtra(parseInt(e.target.value)||0)}/>
                        <span style={{fontSize:11,color:'#8FA3CC'}}>dagen</span>
                        {etikExtra>0&&<span style={{fontSize:10,color:'#C03030',fontWeight:600}}>⚠ Eigen verantwoordelijkheid</span>}
                      </div>
                    </div>
                  )}
                  {/* Preview */}
                  <div style={{border:'1px solid #E4DFD7',borderRadius:6,overflow:'hidden',fontSize:11}}>
                    <div style={{background:'#0C1835',padding:'5px 10px',display:'flex',justifyContent:'space-between'}}>
                      <span style={{color:'#C9A84C',fontWeight:700,fontSize:12}}>{CONFIG.bedrijfsnaam}</span>
                      <span style={{color:'#BCCEFB',fontSize:10}}>HACCP</span>
                    </div>
                    <div style={{padding:'8px 10px',display:'flex',flexDirection:'column',gap:4}}>
                      <div style={{fontSize:13,fontWeight:700,color:'#0C1835'}}>{cur.name}</div>
                      <div style={{fontSize:10,color:'#666'}}>{cur.category}</div>
                      <div style={{borderTop:'1px solid #eee',paddingTop:4,marginTop:2}}>
                        <div style={{display:'flex',justifyContent:'space-between'}}><span style={{color:'#666'}}>Productiedatum</span><span style={{fontWeight:600}}>{fmtDatum(prodDate)}</span></div>
                        {tijdStr&&<div style={{display:'flex',justifyContent:'space-between'}}><span style={{color:'#666'}}>Tijdstip</span><span style={{fontWeight:600}}>{tijdStr}</span></div>}
                        {thtStr&&(<div style={{display:'flex',justifyContent:'space-between'}}><span style={{color:'#666'}}>THT datum</span><span style={{fontWeight:600,color:'#C03030'}}>{thtStr}</span></div>)}
                      </div>
                      {etikMed&&<div style={{display:'flex',justifyContent:'space-between',borderTop:'1px solid #eee',paddingTop:4}}><span style={{color:'#666'}}>Gemaakt door</span><span style={{fontWeight:600}}>{etikMed}</span></div>}
                      {cur.allergenen?.length>0&&(
                        <div style={{borderTop:'1px solid #eee',paddingTop:4}}>
                          <div style={{color:'#666',marginBottom:3}}>Allergenen</div>
                          <div style={{display:'flex',flexWrap:'wrap',gap:3}}>{cur.allergenen.map(a=><span key={a} style={{background:'#FFE9E9',color:'#C03030',fontSize:9,padding:'1px 5px',borderRadius:3,fontWeight:600}}>{a}</span>)}</div>
                        </div>
                      )}
                      {cur.bewaaradvies&&<div style={{borderTop:'1px solid #eee',paddingTop:4,fontSize:10,color:'#666'}}>❄ {cur.bewaaradvies}</div>}
                    </div>
                  </div>{/* end etiket-print-wrapper */}
                  <div style={{display:'flex',gap:8}}>
                    <button style={{flex:1,background:'#C99F3B',border:'none',color:'#0D1B38',padding:10,fontFamily:'inherit',fontSize:13,fontWeight:700,cursor:'pointer',borderRadius:6,WebkitTapHighlightColor:'transparent'}}
                      onTouchEnd={e=>{e.preventDefault();e.stopPropagation();doePrint();}}
                      onClick={doePrint}>Printen</button>
                    <button style={{flex:1,background:'transparent',border:'1px solid #E4DFD7',color:C.txt2,padding:'10px 14px',fontFamily:'inherit',fontSize:13,cursor:'pointer',borderRadius:6,WebkitTapHighlightColor:'transparent'}}
                      onClick={e=>{e.stopPropagation();setPrintEtiket(false);setEtikExtra(0);setEtikProdDatum('');}}>Annuleren</button>
                  </div>
                </div>
              </div>
              );
            })()}
            <div style={{padding:'10px 16px',borderTop:`1px solid ${C.bdr}`,display:'flex',gap:8,flexShrink:0,background:C.bg}}>
              {editing?(<>
                <button style={{flex:1,background:'#0D1B38',border:'none',color:'#fff',padding:10,fontFamily:'inherit',fontSize:13,fontWeight:600,cursor:'pointer',borderRadius:6}} onClick={saveEdit}>Opslaan</button>
                <button style={{flex:1,background:'transparent',border:'1px solid #E4DFD7',color:C.txt2,padding:'10px 14px',fontFamily:'inherit',fontSize:13,cursor:'pointer',borderRadius:6}} onClick={()=>{setEditing(false);setDraft(null);}}>Annuleren</button>
              </>):(<>
                {cur?.checks?.[selectedDay]===2&&(
                  <button style={{background:'#C99F3B',border:'none',color:'#0D1B38',padding:'10px 14px',fontFamily:'inherit',fontSize:13,fontWeight:600,cursor:'pointer',borderRadius:6,flexShrink:0}} onClick={()=>setPrintEtiket(true)}>Etiket</button>
                )}
                <button className="btn-edit" style={{flex:1,background:'transparent',border:`1px solid ${C.amber}`,color:C.amber,padding:9,fontFamily:'inherit',fontSize:12,fontWeight:500,cursor:'pointer',borderRadius:4}} onClick={startEdit}>✏ Bewerken</button>
                {depts.length>1&&!cur?.archived&&(
                  <select onChange={e=>{if(e.target.value)moveItem(selId,e.target.value);e.target.value='';}}
                    style={{background:'transparent',border:`1px solid ${C.bdr}`,color:C.txt2,padding:'9px 6px',fontFamily:'inherit',fontSize:11,cursor:'pointer',borderRadius:4}}
                    defaultValue="">
                    <option value="" disabled>↗ Verplaats</option>
                    {depts.filter(d=>d.id!==activeDept).map(d=><option key={d.id} value={d.id}>{d.name}</option>)}
                  </select>
                )}
                {cur?.archived
                  ? <button style={{background:C.greenBg,border:`1px solid ${C.greenBd}`,color:C.green,padding:'9px 12px',fontFamily:'inherit',fontSize:12,fontWeight:600,cursor:'pointer',borderRadius:4}} onClick={()=>restoreItem(selId)}>↩ Terugzetten</button>
                  : <button style={{background:C.amberBg,border:`1px solid ${C.amberBd}`,color:C.amber,padding:'9px 10px',fontFamily:'inherit',fontSize:12,cursor:'pointer',borderRadius:4}} onClick={()=>archiveItem(selId)} title="Archiveren">Archief</button>
                }
                <button className="btn-del" style={{background:'transparent',border:`1px solid ${C.bdr}`,color:C.txt2,padding:'9px 10px',fontFamily:'inherit',fontSize:12,cursor:'pointer',borderRadius:4}} onClick={()=>deleteItem(selId)}>🗑</button>
              </>)}
            </div>
          </div>
          </div>
        )}

        {/* ══ Recept detail-sheet (Receptenboek) ════════════════════════════ */}
        {selRecipeId && curRecipe && (
          <div className="overlay" onClick={()=>closeRecipe()}>
            <div className="detail-sheet" onClick={e=>e.stopPropagation()} style={{position:'relative'}}>
              {/* Sluit-knop */}
              <button onClick={()=>closeRecipe()}
                style={{position:'absolute',top:10,right:10,background:'transparent',border:'none',fontSize:20,color:C.txt3,cursor:'pointer',padding:'4px 8px',zIndex:2,fontFamily:'inherit'}}>✕</button>
              <div className="sheet-handle"/>

              {/* Header */}
              <div style={{padding:'14px 16px 12px',borderBottom:`1px solid ${C.bdr}`,display:'flex',alignItems:'flex-start',gap:10}}>
                <span style={{fontSize:22,flexShrink:0}}>📖</span>
                <div style={{flex:1,minWidth:0}}>
                  {recipeEditing ? (<>
                    <input
                      style={{width:'100%',background:'transparent',border:'none',borderBottom:`2px solid ${C.amber}`,color:C.txt,fontFamily:'inherit',fontSize:15,fontWeight:700,padding:'2px 0',outline:'none'}}
                      value={recipeDraft.name}
                      placeholder="Recept naam"
                      onChange={e=>setRecipeDraft(d=>({...d,name:e.target.value}))}
                    />
                    <select
                      style={{background:'transparent',border:'none',borderBottom:`1px solid ${C.bdr}`,color:C.txt2,fontFamily:'inherit',fontSize:11,padding:'3px 0',marginTop:4,outline:'none',cursor:'pointer'}}
                      value={recipeDraft.category||'Overig'}
                      onChange={e=>setRecipeDraft(d=>({...d,category:e.target.value}))}
                    >
                      {allCats.map(c=><option key={c} value={c}>{c}</option>)}
                    </select>
                  </>) : (<>
                    <div style={{fontSize:15,fontWeight:700,color:C.txt,wordBreak:'break-word'}}>
                      {curRecipe.name||'(naamloos)'}
                      {curRecipe.archived && <span style={{fontSize:10,color:C.txt3,background:C.bg3,padding:'2px 6px',borderRadius:8,marginLeft:8,fontWeight:500}}>gearchiveerd</span>}
                    </div>
                    <div style={{fontSize:11,color:C.txt2,marginTop:4}}>{curRecipe.category||'Overig'}</div>
                    {(() => {
                      // Verzamel parties waar dit recept gekoppeld is (niet-gearchiveerde items)
                      const inParties = depts
                        .filter(d => d.items.some(it => it.recipe_id === curRecipe.id && !it.archived))
                        .map(d => d.name);
                      if (inParties.length > 0) return (
                        <div style={{fontSize:11,color:C.amber,marginTop:4}}>
                          ⚡ Gekoppeld in: {inParties.join(', ')}
                        </div>
                      );
                      return null;
                    })()}
                  </>)}
                </div>
              </div>

              {/* Body */}
              <div style={{flex:1,overflowY:'auto',padding:16,display:'flex',flexDirection:'column',gap:18}}>

                {/* Bereiding */}
                <div>
                  <div style={{fontSize:10,letterSpacing:1,color:C.txt2,marginBottom:8,fontWeight:600,textTransform:'uppercase'}}>Bereiding</div>
                  {recipeEditing ? (
                    <textarea
                      style={{width:'100%',background:'#FAFAF8',border:`1px solid ${C.bdr}`,color:C.txt,fontFamily:'inherit',fontSize:13,lineHeight:1.6,padding:10,resize:'vertical',outline:'none',minHeight:100,borderRadius:4}}
                      value={recipeDraft.recipe||''}
                      rows={5}
                      onChange={e=>setRecipeDraft(d=>({...d,recipe:e.target.value}))}
                      placeholder="Beschrijf de bereidingswijze..."
                    />
                  ) : (
                    <div style={{fontSize:13,color:curRecipe.recipe?C.txt:C.txt3,lineHeight:1.7,whiteSpace:'pre-wrap',fontStyle:curRecipe.recipe?'normal':'italic'}}>
                      {curRecipe.recipe||'Geen recept-tekst. Klik Bewerken om toe te voegen.'}
                    </div>
                  )}
                </div>

                {/* Ingrediënten */}
                <div>
                  <div style={{fontSize:10,letterSpacing:1,color:C.txt2,marginBottom:8,fontWeight:600,textTransform:'uppercase'}}>
                    Ingrediënten {(curRecipe.ingredients||[]).length>0 && <span style={{fontWeight:400,color:C.txt3}}>({curRecipe.ingredients.length})</span>}
                  </div>
                  {!recipeEditing && (curRecipe.ingredients||[]).length === 0 && (
                    <span style={{fontSize:12,color:C.txt3,fontStyle:'italic'}}>Geen ingrediënten. Klik Bewerken.</span>
                  )}
                  <div style={{display:'flex',flexDirection:'column',gap:4}}>
                    {(recipeEditing ? (recipeDraft.ingredients||[]) : (curRecipe.ingredients||[])).map(ing => recipeEditing ? (
                      <div key={ing.id} style={{display:'flex',alignItems:'center',gap:4,marginBottom:2,flexWrap:'wrap'}}>
                        <input style={{flex:2,minWidth:80,background:'#FAFAF8',border:`1px solid ${C.bdr}`,color:C.txt,padding:'4px 8px',fontFamily:'inherit',fontSize:12,outline:'none',borderRadius:4}}
                          value={ing.name||''} placeholder="Ingrediënt"
                          onChange={e=>setRecipeDraft(d=>({...d,ingredients:d.ingredients.map(i=>i.id===ing.id?{...i,name:e.target.value}:i)}))}/>
                        <input type="number" min="0" style={{width:50,background:'#FAFAF8',border:`1px solid ${C.bdr}`,color:C.txt,padding:'4px 6px',fontFamily:'inherit',fontSize:12,outline:'none',textAlign:'right',borderRadius:4}}
                          value={ing.amount||''} placeholder="0"
                          onChange={e=>setRecipeDraft(d=>({...d,ingredients:d.ingredients.map(i=>i.id===ing.id?{...i,amount:e.target.value}:i)}))}/>
                        <select style={{background:'#FAFAF8',border:`1px solid ${C.bdr}`,color:C.txt2,padding:'4px 3px',fontFamily:'inherit',fontSize:11,outline:'none',borderRadius:4}}
                          value={ing.unit||'g'}
                          onChange={e=>setRecipeDraft(d=>({...d,ingredients:d.ingredients.map(i=>i.id===ing.id?{...i,unit:e.target.value}:i)}))}>
                          {UNITS.map(u=><option key={u} value={u}>{u}</option>)}
                        </select>
                        <button style={{background:'none',border:'none',color:C.txt3,cursor:'pointer',fontSize:13,padding:'0 4px',fontFamily:'inherit'}}
                          onClick={()=>setRecipeDraft(d=>({...d,ingredients:d.ingredients.filter(i=>i.id!==ing.id)}))}>✕</button>
                      </div>
                    ) : (
                      <div key={ing.id} style={{display:'flex',justifyContent:'space-between',padding:'4px 0',borderBottom:`1px dashed ${C.bdr}`,fontSize:12}}>
                        <span style={{color:C.txt}}>{ing.name||'(naamloos)'}</span>
                        <span style={{color:C.txt2,fontFamily:"'DM Mono', monospace"}}>{ing.amount} {ing.unit}</span>
                      </div>
                    ))}
                  </div>
                  {recipeEditing && (
                    <button
                      onClick={()=>setRecipeDraft(d=>({...d,ingredients:[...(d.ingredients||[]),{id:uid(),name:'',amount:'',unit:'g',supplier:'Overig'}]}))}
                      style={{marginTop:8,background:'transparent',border:`1px dashed ${C.bdr2}`,color:C.txt2,padding:'6px 12px',fontSize:11,fontFamily:'inherit',cursor:'pointer',borderRadius:4,width:'100%'}}
                    >+ Ingrediënt toevoegen</button>
                  )}
                </div>

                {/* Allergenen */}
                <div>
                  <div style={{fontSize:10,letterSpacing:1,color:C.txt2,marginBottom:8,fontWeight:600,textTransform:'uppercase'}}>Allergenen</div>
                  {recipeEditing ? (
                    <div style={{display:'flex',flexWrap:'wrap',gap:4}}>
                      {ALLERGENEN.map(a => {
                        const isGluten = a === 'Gluten';
                        const isNoten  = a === 'Noten';
                        const subSel = isGluten ? GLUTEN_SUB.filter(s=>(recipeDraft.allergenen||[]).includes(s)) :
                                       isNoten  ? NOTEN_SUB.filter(s=>(recipeDraft.allergenen||[]).includes(s)) : [];
                        const sel = isGluten || isNoten ? subSel.length > 0 : (recipeDraft.allergenen||[]).includes(a);
                        const label = (isGluten || isNoten) && subSel.length > 0 ? subSel.join(', ') : a;
                        return (
                          <div key={a} style={{position:'relative',display:'inline-block'}}>
                            <button
                              onClick={()=>{
                                if (isGluten) { setRecipeGlutenOpen(o=>!o); return; }
                                if (isNoten)  { setRecipeNotenOpen(o=>!o); return; }
                                setRecipeDraft(d=>({...d,allergenen: sel ? (d.allergenen||[]).filter(x=>x!==a) : [...(d.allergenen||[]),a]}));
                              }}
                              style={{fontSize:11,padding:'4px 9px',fontFamily:'inherit',cursor:'pointer',borderRadius:14,border:`1px solid ${sel?C.red:C.bdr}`,background:sel?C.redBg:'transparent',color:sel?C.red:C.txt2,fontWeight:sel?600:400}}
                            >{label}{(isGluten||isNoten)?' ▾':''}</button>
                            {isGluten && recipeGlutenOpen && (
                              <div style={{position:'absolute',top:'100%',left:0,background:'#fff',border:`1px solid ${C.bdr}`,borderRadius:6,padding:6,zIndex:50,minWidth:140,boxShadow:'0 4px 12px rgba(0,0,0,.1)',marginTop:4}}>
                                {GLUTEN_SUB.map(s => {
                                  const ss = (recipeDraft.allergenen||[]).includes(s);
                                  return (
                                    <div key={s} style={{padding:'4px 8px',cursor:'pointer',borderRadius:4,background:ss?C.redBg:'transparent',color:ss?C.red:C.txt,fontSize:12}}
                                      onClick={()=>setRecipeDraft(d=>({...d,allergenen: ss ? (d.allergenen||[]).filter(x=>x!==s) : [...(d.allergenen||[]).filter(x=>!GLUTEN_SUB.includes(x)&&x!=='Gluten'),s]}))}>
                                      {ss?'✓ ':''}{s}
                                    </div>
                                  );
                                })}
                                <div style={{borderTop:`1px solid ${C.bdr}`,marginTop:4,paddingTop:4,padding:'4px 8px',cursor:'pointer',color:C.txt3,fontSize:11}}
                                  onClick={()=>{setRecipeGlutenOpen(false); setRecipeDraft(d=>({...d,allergenen:(d.allergenen||[]).filter(x=>!GLUTEN_SUB.includes(x)&&x!=='Gluten')}));}}>
                                  Wis Gluten
                                </div>
                              </div>
                            )}
                            {isNoten && recipeNotenOpen && (
                              <div style={{position:'absolute',top:'100%',left:0,background:'#fff',border:`1px solid ${C.bdr}`,borderRadius:6,padding:6,zIndex:50,minWidth:160,boxShadow:'0 4px 12px rgba(0,0,0,.1)',marginTop:4}}>
                                {NOTEN_SUB.map(s => {
                                  const ss = (recipeDraft.allergenen||[]).includes(s);
                                  return (
                                    <div key={s} style={{padding:'4px 8px',cursor:'pointer',borderRadius:4,background:ss?C.redBg:'transparent',color:ss?C.red:C.txt,fontSize:12}}
                                      onClick={()=>setRecipeDraft(d=>({...d,allergenen: ss ? (d.allergenen||[]).filter(x=>x!==s) : [...(d.allergenen||[]).filter(x=>!NOTEN_SUB.includes(x)&&x!=='Noten'),s]}))}>
                                      {ss?'✓ ':''}{s}
                                    </div>
                                  );
                                })}
                                <div style={{borderTop:`1px solid ${C.bdr}`,marginTop:4,paddingTop:4,padding:'4px 8px',cursor:'pointer',color:C.txt3,fontSize:11}}
                                  onClick={()=>{setRecipeNotenOpen(false); setRecipeDraft(d=>({...d,allergenen:(d.allergenen||[]).filter(x=>!NOTEN_SUB.includes(x)&&x!=='Noten')}));}}>
                                  Wis Noten
                                </div>
                              </div>
                            )}
                          </div>
                        );
                      })}
                    </div>
                  ) : (curRecipe.allergenen||[]).length > 0 ? (
                    <div style={{display:'flex',flexWrap:'wrap',gap:4}}>
                      {curRecipe.allergenen.map(a => (
                        <span key={a} style={{fontSize:11,padding:'3px 9px',background:C.redBg,color:C.red,border:`1px solid ${C.redBd}`,borderRadius:14,fontWeight:600}}>{a}</span>
                      ))}
                    </div>
                  ) : (
                    <span style={{fontSize:12,color:C.txt3,fontStyle:'italic'}}>Geen allergenen.</span>
                  )}
                </div>

                {/* THT + bewaaradvies */}
                <div style={{display:'flex',gap:12,flexWrap:'wrap'}}>
                  <div style={{flex:1,minWidth:120}}>
                    <div style={{fontSize:10,letterSpacing:1,color:C.txt2,marginBottom:6,fontWeight:600,textTransform:'uppercase'}}>THT (dagen)</div>
                    {recipeEditing ? (
                      <input type="number" min="0"
                        style={{width:80,background:'#FAFAF8',border:`1px solid ${C.bdr}`,color:C.txt,padding:'5px 8px',fontFamily:'inherit',fontSize:12,outline:'none',borderRadius:4}}
                        value={recipeDraft.tht_dagen??''} placeholder="bv. 5"
                        onChange={e=>setRecipeDraft(d=>({...d,tht_dagen: e.target.value ? parseInt(e.target.value,10) : null}))}/>
                    ) : (
                      <div style={{fontSize:13,color:curRecipe.tht_dagen?C.txt:C.txt3,fontStyle:curRecipe.tht_dagen?'normal':'italic'}}>
                        {curRecipe.tht_dagen ? `${curRecipe.tht_dagen} dagen na productie` : 'niet ingesteld'}
                      </div>
                    )}
                  </div>
                  <div style={{flex:2,minWidth:160}}>
                    <div style={{fontSize:10,letterSpacing:1,color:C.txt2,marginBottom:6,fontWeight:600,textTransform:'uppercase'}}>Bewaaradvies</div>
                    {recipeEditing ? (
                      <select
                        style={{width:'100%',background:'#FAFAF8',border:`1px solid ${C.bdr}`,color:C.txt,padding:'5px 8px',fontFamily:'inherit',fontSize:12,outline:'none',borderRadius:4,cursor:'pointer'}}
                        value={recipeDraft.bewaaradvies||''}
                        onChange={e=>setRecipeDraft(d=>({...d,bewaaradvies:e.target.value}))}>
                        {BEWAARADVIES.map(b => <option key={b||'(geen)'} value={b}>{b||'— geen bewaaradvies —'}</option>)}
                      </select>
                    ) : (
                      <div style={{fontSize:13,color:curRecipe.bewaaradvies?C.txt:C.txt3,fontStyle:curRecipe.bewaaradvies?'normal':'italic'}}>
                        {curRecipe.bewaaradvies || 'niet ingesteld'}
                      </div>
                    )}
                  </div>
                </div>

                <div style={{display:'flex',gap:8,marginTop:8,paddingTop:14,borderTop:`1px solid ${C.bdr}`,flexWrap:'wrap'}}>
                  {recipeEditing ? (<>
                    <button onClick={saveEditRecipe}
                      style={{background:C.amber,border:'none',color:'#0D1B38',padding:'8px 18px',fontFamily:'inherit',fontSize:12,fontWeight:600,cursor:'pointer',borderRadius:4}}
                    >✓ Opslaan</button>
                    <button onClick={()=>{setRecipeEditing(false);setRecipeDraft(null);}}
                      style={{background:'transparent',border:`1px solid ${C.bdr}`,color:C.txt2,padding:'8px 14px',fontFamily:'inherit',fontSize:12,cursor:'pointer',borderRadius:4}}
                    >Annuleren</button>
                  </>) : (<>
                    <button onClick={startEditRecipe}
                      style={{background:C.amber,border:'none',color:'#0D1B38',padding:'8px 18px',fontFamily:'inherit',fontSize:12,fontWeight:600,cursor:'pointer',borderRadius:4}}
                    >✏ Bewerken</button>
                    <div style={{flex:1}}/>
                    <button onClick={()=>archiveRecipe(curRecipe.id, !curRecipe.archived)}
                      style={{background:'transparent',border:`1px solid ${C.bdr}`,color:C.txt2,padding:'8px 12px',fontFamily:'inherit',fontSize:12,cursor:'pointer',borderRadius:4}}
                    >{curRecipe.archived?'↩ Herstellen':'📁 Archiveren'}</button>
                    <button onClick={()=>deleteRecipe(curRecipe.id)}
                      style={{background:'transparent',border:`1px solid ${C.redBd}`,color:C.red,padding:'8px 12px',fontFamily:'inherit',fontSize:12,cursor:'pointer',borderRadius:4}}
                    >🗑 Verwijderen</button>
                  </>)}
                </div>

              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

const CSS = `
  @import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@300;400;500;600&family=DM+Mono:wght@400;500&display=swap');

  * { font-family: 'DM Sans', system-ui, sans-serif !important; box-sizing: border-box; }
  body { background: #F5F3EF; }

  input, textarea, select {
    background: #FFFFFF !important;
    color: #0D1B38 !important;
    -webkit-text-fill-color: #0D1B38 !important;
    font-family: 'DM Sans', system-ui, sans-serif !important;
  }

  /* ── Day selector ── */
  .day-selector {
    background: #ffffff;
    border-bottom: 1px solid #E4DFD7;
    padding: 12px 16px;
    display: flex;
    gap: 6px;
    overflow-x: auto;
    scrollbar-width: none;
    -webkit-overflow-scrolling: touch;
    flex-shrink: 0;
  }
  .day-selector::-webkit-scrollbar { display: none; }
  .day-btn {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 7px 12px;
    border-radius: 8px;
    border: 1px solid #E4DFD7;
    background: #F5F3EF;
    min-width: 52px;
    flex-shrink: 0;
    cursor: pointer;
    transition: all .15s;
    -webkit-tap-highlight-color: transparent;
    touch-action: manipulation;
  }
  .day-btn.active {
    background: #0D1B38;
    border-color: #0D1B38;
    box-shadow: 0 2px 8px rgba(13,27,56,.2);
  }
  .day-btn .day-letter {
    font-size: 11px;
    font-weight: 600;
    letter-spacing: 1px;
    text-transform: uppercase;
    color: #7A8899;
  }
  .day-btn .day-num {
    font-size: 15px;
    font-weight: 600;
    color: #0D1B38;
    margin-top: 2px;
  }
  .day-btn.active .day-letter,
  .day-btn.active .day-num { color: #ffffff; }
  .day-btn.today .day-num { color: #C99F3B; }
  .day-btn.active.today .day-num { color: #C99F3B; }
  .day-btn.active span[style*="border-radius: 50%"] { opacity: 0.7; }

  /* ── Progress bar ── */
  .progress-bar {
    background: #ffffff;
    border-bottom: 1px solid #E4DFD7;
    padding: 8px 16px;
    display: flex;
    align-items: center;
    gap: 12px;
    flex-shrink: 0;
  }
  .progress-track {
    flex: 1;
    height: 4px;
    background: #E4DFD7;
    border-radius: 2px;
    overflow: hidden;
  }
  .progress-fill {
    height: 100%;
    border-radius: 2px;
    background: linear-gradient(90deg, #1A2E5A, #C99F3B);
    transition: width .4s ease;
  }
  .progress-label {
    font-size: 12px;
    font-weight: 600;
    color: #7A8899;
    white-space: nowrap;
    min-width: 48px;
    text-align: right;
  }

  /* ── Checkboxes ── */
  .chk {
    width: 22px; height: 22px; flex-shrink: 0;
    border: 1.5px solid #D4CEC5;
    border-radius: 6px;
    display: inline-flex; align-items: center; justify-content: center;
    cursor: pointer;
    transition: all .15s;
    background: #F5F3EF;
    -webkit-tap-highlight-color: transparent;
    touch-action: manipulation;
    user-select: none; -webkit-user-select: none;
  }
  .chk-1 { background: #FFFFFF !important; border-color: #0D1B38 !important; color: #0D1B38 !important; font-size: 12px; font-weight: 700; }
  .chk-2 { background: #FFFFFF !important; border-color: #22C55E !important; color: #22C55E !important; font-size: 15px; font-weight: 700; }
  @media (hover: hover) {
    .chk:not(.chk-1):not(.chk-2):hover { border-color: #2C4175 !important; background: rgba(13,27,56,.04) !important; }
    .chk-1:hover { background: #F0F0F0 !important; }
    .chk-2:hover { background: #ECFDF5 !important; }
  }

  /* ── Sync badge ── */
  .sync-badge {
    display: flex; align-items: center; gap: 4px;
    font-size: 11.5px; color: #2A9D5C;
    background: rgba(42,157,92,.12);
    border: 1px solid rgba(42,157,92,.20);
    padding: 3px 8px; border-radius: 20px;
  }
  .sync-dot {
    width: 5px; height: 5px; border-radius: 50%;
    background: #2A9D5C;
    box-shadow: 0 0 6px #2A9D5C;
    animation: syncPulse 2.5s infinite;
  }
  .sync-badge.syncing { color: #C99F3B; background: rgba(201,159,59,.12); border-color: rgba(201,159,59,.20); }
  .sync-badge.syncing .sync-dot { background: #C99F3B; box-shadow: 0 0 6px #C99F3B; }
  @keyframes syncPulse { 0%, 100% { opacity: 1; } 50% { opacity: 0.3; } }

  /* ── Buttons ── */
  .btn {
    display: inline-flex; align-items: center; gap: 5px;
    padding: 7px 13px; border-radius: 4px;
    font-family: 'DM Sans', sans-serif !important;
    font-size: 12.5px; font-weight: 500;
    cursor: pointer; border: none;
    transition: all .15s ease;
    white-space: nowrap;
    -webkit-tap-highlight-color: transparent;
  }
  .btn-ghost {
    background: rgba(255,255,255,.06);
    color: rgba(255,255,255,.75);
    border: 1px solid rgba(255,255,255,.10) !important;
  }
  .btn-primary {
    background: #C99F3B;
    color: #0D1B38;
    font-weight: 600;
    box-shadow: 0 2px 8px rgba(201,159,59,.30);
  }
  @media (hover: hover) {
    .btn-ghost:hover { background: rgba(255,255,255,.12); color: #fff; border-color: rgba(255,255,255,.20) !important; }
    .btn-primary:hover { background: #E0B94A; box-shadow: 0 3px 12px rgba(201,159,59,.40); transform: translateY(-1px); }
    .dept-tab:hover { color: #C99F3B !important; }
    .btn-add-dept:hover { color: #C99F3B !important; }
  }

  /* ── Category header ── */
  .cat-header {
    display: flex; align-items: center; gap: 8px;
    padding: 10px 16px 8px;
    background: #F5F3EF;
    border-bottom: 1px solid #E4DFD7;
  }
  .cat-name {
    font-size: 11px; font-weight: 700;
    letter-spacing: 1.5px; text-transform: uppercase;
    color: #3D4F6E;
  }
  .cat-count {
    margin-left: auto;
    font-size: 11px;
    font-family: 'DM Mono', monospace !important;
    color: #7A8899;
    background: #E4DFD7;
    padding: 1px 6px; border-radius: 10px;
  }
  .cat-count.all-done { color: #2A9D5C; background: #EDF7F2; }

  /* ── Item rows ── */
  .irow {
    display: flex; align-items: center;
    padding: 0 16px;
    border-bottom: 1px solid #E4DFD7;
    background: #ffffff;
    min-height: 52px;
    gap: 12px;
    transition: background .1s;
  }
  .irow:active { background: #FAF9F7; }
  .irow-sel { background: #FAF9F7 !important; }
  .irow-sel .iname { font-weight: 600; color: #0D1B38 !important; }
  @media (hover: hover) { .irow:hover { background: #FAF9F7; } }

  /* Item tags */
  .item-tag {
    font-size: 10.5px; font-weight: 600;
    letter-spacing: 0.5px; padding: 1px 6px;
    border-radius: 3px; text-transform: uppercase;
  }
  .tag-recept { background: rgba(13,27,56,.07); color: #2C4175; }
  .tag-allergen { background: #FDF1F0; color: #C0392B; }

  /* Icon buttons */
  .icon-btn {
    width: 28px; height: 28px;
    display: flex; align-items: center; justify-content: center;
    border: none; background: none; cursor: pointer;
    border-radius: 4px; color: #7A8899;
    transition: all .15s; flex-shrink: 0;
  }
  @media (hover: hover) {
    .icon-btn:hover { background: #F0EDE8; color: #0D1B38; }
    .icon-btn.delete:hover { background: #FDF1F0; color: #C0392B; }
  }

  /* ── Bottom sheet overlay ── */
  .overlay {
    position: fixed; inset: 0;
    background: rgba(13,27,56,.40);
    backdrop-filter: blur(2px);
    z-index: 100;
    display: flex; align-items: flex-end; justify-content: center;
    animation: overlayIn .2s ease;
  }
  @keyframes overlayIn { from { opacity: 0; } to { opacity: 1; } }
  .detail-sheet {
    background: #ffffff;
    border-radius: 16px 16px 0 0;
    width: 100%; max-height: 92vh;
    max-width: 820px;
    margin: 0 auto;
    overflow-y: auto;
    box-shadow: 0 -8px 40px rgba(13,27,56,.15);
    animation: sheetUp .28s cubic-bezier(.32,.72,0,1);
  }
  @keyframes sheetUp { from { transform: translateY(100%); } to { transform: translateY(0); } }
  .sheet-handle {
    width: 36px; height: 4px;
    background: #E4DFD7; border-radius: 2px;
    margin: 10px auto 0;
  }
  .sheet-label {
    font-size: 10.5px; font-weight: 700;
    letter-spacing: 1.5px; text-transform: uppercase;
    color: #A07E28; margin-bottom: 8px;
  }

  /* ── Dept tabs ── */
  .dept-tab { -webkit-tap-highlight-color: transparent; touch-action: manipulation; }
  .htab { -webkit-tap-highlight-color: transparent; touch-action: manipulation; }

  /* ── Misc ── */
  input:focus, textarea:focus, select:focus {
    border-color: #C99F3B !important;
    box-shadow: 0 0 0 2px rgba(201,159,59,.15) !important;
    outline: none;
  }
  ::-webkit-scrollbar { width: 5px; height: 5px; }
  ::-webkit-scrollbar-track { background: #F5F3EF; }
  ::-webkit-scrollbar-thumb { background: #E4DFD7; border-radius: 3px; }
  header div::-webkit-scrollbar { display: none; }

  /* ── Sidebar ── */
  .sidebar {
    position: fixed; top: 0; left: 0; bottom: 0;
    width: 280px; background: #FFFFFF;
    z-index: 201;
    transform: translateX(-280px);
    transition: transform .3s cubic-bezier(.32,.72,0,1);
    display: flex; flex-direction: column;
    box-shadow: 4px 0 32px rgba(0,0,0,.12);
    border-right: 1px solid #E4DFD7;
  }
  .sidebar.open { transform: translateX(0); }
  .sidebar-overlay {
    position: fixed; inset: 0;
    background: rgba(13,27,56,.35);
    backdrop-filter: blur(2px);
    z-index: 200; opacity: 0; pointer-events: none;
    transition: opacity .28s ease;
  }
  .sidebar-overlay.open { opacity: 1; pointer-events: all; }
  .nav-item {
    display: flex; align-items: center; gap: 0;
    padding: 12px 20px;
    border-left: 3px solid transparent;
    cursor: pointer; transition: all .15s;
    color: #4A5D8A; font-size: 13.5px;
    -webkit-tap-highlight-color: transparent;
    touch-action: manipulation;
  }
  .nav-item:hover { background: rgba(13,27,56,.04); color: #0C1835; border-left-color: rgba(201,159,59,.4); }
  .nav-item.active { background: rgba(201,159,59,.10); border-left-color: #C99F3B; }
  .nav-item.active .nav-label { color: #C99F3B; font-weight: 600; }
  .nav-item:hover .nav-label { color: #0C1835; }
  .nav-icon { display: none; }
  .nav-label { font-size: 14px; font-weight: 500; color: #4A5D8A; flex: 1; }
  .nav-badge {
    margin-left: auto; background: #C99F3B; color: #0D1B38;
    font-size: 10.5px; font-weight: 700;
    padding: 2px 7px; border-radius: 10px; min-width: 20px; text-align: center;
  }
  .nav-badge.green { background: #2A9D5C; color: #fff; }

  .sidebar-section-label {
    font-size: 10px; font-weight: 700;
    letter-spacing: 2px; text-transform: uppercase;
    color: #8FA0C0;
    padding: 16px 20px 6px;
  }
  .sidebar-divider {
    height: 1px; background: #E4DFD7;
    margin: 8px 20px;
  }
  .sidebar-footer {
    padding: 12px 20px;
    border-top: 1px solid #E4DFD7;
    font-size: 11px; color: #8FA0C0;
    display: flex; align-items: center; justify-content: space-between;
    flex-shrink: 0;
  }

  /* ── Search ── */
  .search-bar { background: #fff; border-bottom: 1px solid #E4DFD7; padding: 8px 16px; display: flex; align-items: center; gap: 10px; }
  .search-input { flex: 1; border: 1px solid #E4DFD7; border-radius: 6px; padding: 7px 12px; font-family: 'DM Sans', sans-serif; font-size: 13px; color: #0D1B38; outline: none; transition: border-color .15s; }
  .search-input:focus { border-color: #C99F3B; box-shadow: 0 0 0 2px rgba(201,159,59,.15); }

  /* ── Undo bar ── */
  .undo-bar {
    position: fixed; bottom: 20px; left: 50%;
    transform: translateX(-50%);
    background: #0D1B38; color: #fff;
    display: flex; align-items: center; gap: 12px;
    padding: 10px 16px; border-radius: 24px;
    box-shadow: 0 4px 20px rgba(0,0,0,.3);
    border: 1px solid rgba(201,159,59,.3);
    font-size: 12px; z-index: 300; white-space: nowrap;
    animation: slideUp .2s ease;
    overflow: hidden;
  }
  @keyframes slideUp { from{transform:translateX(-50%) translateY(20px);opacity:0} to{transform:translateX(-50%) translateY(0);opacity:1} }
  .undo-btn { background: #C99F3B; color: #0D1B38; border: none; border-radius: 12px; padding: 4px 12px; font-size: 11px; font-weight: 700; cursor: pointer; font-family: inherit; }
  .undo-progress { position: absolute; bottom: 0; left: 0; height: 3px; background: #C99F3B; animation: shrink 4s linear forwards; }
  @keyframes shrink { from{width:100%} to{width:0} }

  @media (max-width: 700px) {
    .panel-el { width: 100% !important; border-left: none !important; }
    .main-hide { display: none !important; }
  }

`;
